import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, inject, Injectable, resource } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTab, MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { DynamicFormsComponent } from '../dynamic-forms/dynamic-forms.component';
//import { formFields, formMetaData } from '../shared/dynamic-forms.interface';
import { catchError, combineLatest, forkJoin, map, Observable, of, sample, switchMap, take, tap } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { DynamicFormsV2Component } from '../shared/dynamic-forms-v2/dynamic-forms-v2.component';
import { CodeableConceptField, CodeField, GroupField, IndividualField, IndividualReferenceField, ReferenceFieldArray, formMetaData, codeableConceptDataType, ReferenceDataType, codingDataType, SingleCodeField, CodeableConceptFieldFromBackEnd, generalFieldsData } from '../shared/dynamic-forms.interface2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessMessageComponent } from '../shared/success-message/success-message.component';
//import { EncounterServiceService } from './encounter-service.service';
import { MatMenuModule } from '@angular/material/menu';
import { FormFieldsSelectDataService } from '../shared/form-fields-select-data.service';
import { ErrorService } from '../shared/error.service';
import { SidemenuComponent } from '../sidemenu/sidemenu.component';
import { DashboardsWrapperComponent } from '../dashboards-wrapper/dashboards-wrapper.component';
import { TopbreadcrumbComponent } from '../topbreadcrumb/topbreadcrumb.component';
import { TopProfileComponent } from '../top-profile/top-profile.component';
import { PatientSidedetailsComponent } from '../patient-sidedetails/patient-sidedetails.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { StateService } from '../shared/state.service';
type FormFields = IndividualField | ReferenceFieldArray | CodeableConceptField | CodeField | IndividualReferenceField | GroupField;

import { BehaviorSubject } from 'rxjs';
import { EncounterCheckComponent } from '../encounter-check/encounter-check.component';
import { ResumeConsultationDialogComponent } from './resume-consultation-dialog/resume-consultation-dialog.component';
import { AddLabRequestsComponent } from '../lab-requests/add-lab-requests/add-lab-requests.component';
import { AddMedicineRequestsComponent } from '../medicine-requests/add-medicine-requests/add-medicine-requests.component';
import { AddObservationComponent } from '../patient-observation/add-observation/add-observation.component';
// import { TestingTasksComponent } from '../testing-tasks/testing-tasks.component';
// import { AddAlllergyComponent } from '../allergy/add-alllergy/add-alllergy.component';
import { AddAllergyComponent } from '../allergy/add-allergy/add-allergy.component';
import { UtilityService } from '../shared/utility.service';
import { AuthService } from '../shared/auth/auth.service';
import { backendEndPointToken, hardCodedHospitalId, terminologyCanonicalUrlBaseToken } from '../app.config';
// import { MedicationRequest, Resource } from 'fhir/r4';
// import { assert } from 'fhirclient/lib/lib';
import { FhirResourceTransformService } from '../shared/fhir-resource-transform.service';
import { FhirResourceService } from '../shared/fhir-resource.service';
import { LoadingUIEnabled, SkipHospitalSegregation } from '../loading.interceptor';
import { sub } from 'date-fns';
import { Bundle, ChargeItem, ChargeItemDefinition, CodeableConcept, Communication, DiagnosticReport, ImagingStudy, MedicationRequest, Observation, Practitioner, PractitionerRole, Procedure, Reference, ServiceRequest } from 'fhir/r4';
import { ChargeItemBuilderService } from '../shared/charge-item-builder.service';
import { id } from '@swimlane/ngx-charts';
import { Invoice } from 'fhir/r4';
import { inferServiceRequestType } from '../shared/service-request-type.util';
import { ROLE_DISPLAY_NAMES, SystemRoles } from '../shared/system-roles';
import { MessagingParticipant, MessagingSubject, EnsureThreadResponse } from '../messaging/messaging.models';
import { MessagingThreadsService } from '../messaging/messaging-threads.service';
// import { Medication } from 'fhir/r5';
import { NotificationService } from '../services/notification.service'
import { FirebaseAlertService } from '../shared/services/firebase-alert.service';
import { ResourceRefreshService } from '../shared/resource-refresh.service';



@Injectable({
  providedIn: 'root'
})
export class EncounterServiceService {
  route = inject(ActivatedRoute);
  sn = inject(MatSnackBar);
  dialog = inject(MatDialog);
  http = inject(HttpClient);
  authService = inject(AuthService);
  backendEndPoint = inject(backendEndPointToken);
  private notificationService = inject(NotificationService);
  private firebaseAlertService = inject(FirebaseAlertService);
  private resourceRefresh = inject(ResourceRefreshService);
  private messagingThreadsService = inject(MessagingThreadsService);

  encounterState: Observable<any> | undefined;
  patientId: string = '';
  links: string[] = ['summary', 'observations', 'conditions', 'medications'];
  // 'medications', 'procedures', 'immunizations', 'allergies', 'encounters'];
  activeLink = this.links[0];
  //ecounterService = inject(EncounterServiceService)

  resolvedData: any;

  globalEncounterState: Record<
    string,
    BehaviorSubject<
      'planned' | 'in-progress' | 'on-hold' | 'discharged' | 'completed' | 'cancelled' | 'discontinued' | 'entered-in-error' | 'unknown'
    >
  > = {};
  // Configurable list of required vitals that must be filled before proceeding
  requiredVitals: string[] = ['temperature', 'pulseRate', 'respiratoryRate', 'bloodPressure', 'oxygenSaturation'];

  // Local builder for vitals Observations (used if dialog does not supply pre-built list)
  private buildVitalsObservations(v: any, patientId: string, encounterId?: string, performerRef?: string, effectiveDateTime?: string): any[] {
    const subject = { reference: `Patient/${patientId}` };
    const effective = effectiveDateTime || new Date().toISOString();
    const vitalCat = [{ coding: [{ system: 'http://terminology.hl7.org/CodeSystem/observation-category', code: 'vital-signs', display: 'Vital Signs' }], text: 'Vital Signs' }];
    const examCat = [{ coding: [{ system: 'http://terminology.hl7.org/CodeSystem/observation-category', code: 'exam', display: 'Exam' }], text: 'Exam' }];
    // SNOMED CT mapping for appearance & gait common clinical descriptors
    const appearanceMap: Record<string, { code: string; display: string }> = {
      'well': { code: '102876003', display: 'Well' }, // Clinical finding present
      'unwell': { code: '271838008', display: 'Unwell' },
      'pale': { code: '271807003', display: 'Pallor' },
      'flushed': { code: '248196009', display: 'Flushed face' },
      'icteric': { code: '267036007', display: 'Jaundice' },
      'lethargic': { code: '248279007', display: 'Lethargic' },
      'active': { code: '224960004', display: 'Active' },
      'agitated': { code: '271794005', display: 'Agitated' },
      'calm': { code: '272151009', display: 'Calm' },
      'compliant': { code: '105480006', display: 'Cooperative' },
      'combative': { code: '271795006', display: 'Aggressive behaviour' }
    };
    const gaitMap: Record<string, { code: string; display: string }> = {
      'walks normally': { code: '248263006', display: 'Normal gait' },
      'walks with support': { code: '282301002', display: 'Gait difficulty' },
      'walks with limp': { code: '282300003', display: 'Antalgic gait' },
      'unable to walk': { code: '282310008', display: 'Unable to walk' }
    };
    const base = () => ({
      resourceType: 'Observation',
      status: 'final',
      subject,
      effectiveDateTime: effective,
      ...(encounterId ? { encounter: { reference: `Encounter/${encounterId}` } } : {}),
      ...(performerRef ? { performer: [{ reference: performerRef }] } : {})
    });
    const obs: any[] = [];
    if (v?.temperature) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '8310-5', display: 'Body temperature' }], text: 'Body temperature' }, valueQuantity: { value: Number(v.temperature), unit: 'Ã‚Â°C', system: 'http://unitsofmeasure.org', code: 'Cel' } });
    if (v?.pulseRate) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '8867-4', display: 'Heart rate' }], text: 'Heart rate' }, valueQuantity: { value: Number(v.pulseRate), unit: '/min', system: 'http://unitsofmeasure.org', code: '/min' } });
    if (v?.respiratoryRate) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '9279-1', display: 'Respiratory rate' }], text: 'Respiratory rate' }, valueQuantity: { value: Number(v.respiratoryRate), unit: '/min', system: 'http://unitsofmeasure.org', code: '/min' } });
    if (v?.oxygenSaturation) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '59408-5', display: 'Oxygen saturation in Arterial blood by Pulse oximetry' }], text: 'SpO2' }, valueQuantity: { value: Number(v.oxygenSaturation), unit: '%', system: 'http://unitsofmeasure.org', code: '%' } });
    if (v?.height) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '8302-2', display: 'Body height' }], text: 'Height' }, valueQuantity: { value: Number(v.height), unit: 'cm', system: 'http://unitsofmeasure.org', code: 'cm' } });
    if (v?.weight) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '29463-7', display: 'Body weight' }], text: 'Weight' }, valueQuantity: { value: Number(v.weight), unit: 'kg', system: 'http://unitsofmeasure.org', code: 'kg' } });
    if (v?.bmi) obs.push({ ...base(), category: vitalCat, code: { coding: [{ system: 'http://loinc.org', code: '39156-5', display: 'Body mass index (BMI) [Ratio]' }], text: 'BMI' }, valueQuantity: { value: Number(v.bmi), unit: 'kg/m2', system: 'http://unitsofmeasure.org', code: 'kg/m2' } });
    if (v?.bloodPressure && /^\d{1,3}\/\d{1,3}$/.test(String(v.bloodPressure))) {
      const [sys, dia] = String(v.bloodPressure).split('/').map((n: any) => Number(n));
      obs.push({
        ...base(),
        category: vitalCat,
        code: { coding: [{ system: 'http://loinc.org', code: '85354-9', display: 'Blood pressure panel with all children optional' }], text: 'Blood Pressure' },
        component: [
          { code: { coding: [{ system: 'http://loinc.org', code: '8480-6', display: 'Systolic blood pressure' }] }, valueQuantity: { value: sys, unit: 'mmHg', system: 'http://unitsofmeasure.org', code: 'mm[Hg]' } },
          { code: { coding: [{ system: 'http://loinc.org', code: '8462-4', display: 'Diastolic blood pressure' }] }, valueQuantity: { value: dia, unit: 'mmHg', system: 'http://unitsofmeasure.org', code: 'mm[Hg]' } }
        ]
      });
    }
    if (v?.appearance) {
      const raw = String(v.appearance).trim();
      const key = raw.toLowerCase();
      const mapped = appearanceMap[key];
      obs.push({
        ...base(),
        category: examCat,
        code: { text: 'Appearance' },
        valueCodeableConcept: mapped
          ? { coding: [{ system: 'http://snomed.info/sct', code: mapped.code, display: mapped.display }], text: mapped.display }
          : { text: raw }
      });
    }
    if (v?.gait) {
      const raw = String(v.gait).trim();
      const key = raw.toLowerCase();
      const mapped = gaitMap[key];
      obs.push({
        ...base(),
        category: examCat,
        code: { text: 'Gait' },
        valueCodeableConcept: mapped
          ? { coding: [{ system: 'http://snomed.info/sct', code: mapped.code, display: mapped.display }], text: mapped.display }
          : { text: raw }
      });
    }
    return obs;
  }

  // Coerce any heterogeneous value (string | flat object | CodeableConcept) to a CodeableConcept-like object
  private coerceCodeableConcept(v: any): { coding?: Array<{ system?: string; code?: string; display?: string }>; text?: string } | null {
    if (!v) return null;
    // Already a CodeableConcept
    if (typeof v === 'object' && Array.isArray(v.coding)) return v;
    // Flat object with code/display/system
    if (typeof v === 'object' && (v.code || v.display || v.system)) {
      const code = v.code || '';
      const display = v.display || v.text || '';
      const system = v.system || '';
      return { coding: [{ code, display, system }], text: display || code };
    }
    // Encoded string: code$#$display$#$system or free text
    if (typeof v === 'string') {
      if (v.includes('$#$')) {
        const [code = '', display = '', system = ''] = v.split('$#$');
        return { coding: [{ code, display, system }], text: display || code };
      }
      return { text: v };
    }
    return null;
  }

  private getRequiredObservationsExtensionUrl(): string {
    const terminologyServer = (this.backendEndPoint || '').toString().replace(/\/$/, '');
    return `${this.terminologyServer}/fhir/StructureDefinition/required-observations`;
  }
  terminologyServer = inject(terminologyCanonicalUrlBaseToken);
  private isItemsUsageComputationActivityDefinition(activity: any): boolean {
    const topics: any[] = Array.isArray(activity?.topic) ? activity.topic : [];
    return topics.some((t: any) => (t?.text || '').toString().trim().toLowerCase() === 'items usage computation');
  }

  getConfiguredRequiredObservationCodes$(serviceCode: string): Observable<any[]> {
    console.log('Getting required observation codes for service code:', serviceCode);
    const code = (serviceCode || '').toString().trim().toLowerCase();
    if (!code) return of([]);

    const defsWrapped = (this.stateService?.orgWideResources?.activityDefinitions?.getValue?.() || []) as any[];
    const defs = defsWrapped.map((w: any) => w?.actualResource).filter(Boolean);

    const checkMatch = (activityDefs: any[]): any[] => {
      const match = activityDefs.find((ad: any) => {
        const isActive = (ad?.status || '').toString().toLowerCase() === 'active';
        if (!isActive) return false;
        if (!this.isItemsUsageComputationActivityDefinition(ad)) return false;
        const codings = Array.isArray(ad?.code?.coding) ? ad.code.coding : [];
        return codings.some((c: any) => {
          console.log('Checking coding for match:', c?.code, code);
         return (c?.code || '').toString().trim().toLowerCase() === code
        }
        );
      });

      if (!match) return [];

      const url = this.getRequiredObservationsExtensionUrl();
      const exts = Array.isArray(match?.extension) ? match.extension : [];
      return exts
        .filter((e: any) => e?.url === url)
        .map((e: any) => e?.valueCodeableConcept)
        .filter(Boolean);
    };

    const cachedCodes = checkMatch(defs);
    if (cachedCodes.length > 0 || defs.length > 0) {
      return of(cachedCodes);
    }

    return this.utilityService.threeTierQueryAndSyncToStateOnce$<any>({
        resourceType: 'ActivityDefinition',
        scope: 'orgWide',
        urlSearchObject: { status: 'active' },
        querySearchObject: [
            { key: 'status', value: 'active' },
            { key: 'code.coding.code', value: code }
        ],
        tier1FollowNextLinks: true,
        tier1MaxPages: 10,
        count: 100
    }).pipe(
        map((fetchedDefs: any[]) => {
          console.log('Fetched ActivityDefinitions for required observations:', fetchedDefs);
          return checkMatch(fetchedDefs || []);
        }),
        catchError(() => of([]))
    );
  }

  // Build Encounter resource from dialog values
  private buildEncounterResource(patientId: string, details: any, actors: any): any {
    const patientRef = { reference: `Patient/${patientId}` };
    // Normalize class and priority to CodeableConcept, then derive Coding/CodeableConcept as required
    const classCC = this.coerceCodeableConcept(details?.class);
    const priorityCC = this.coerceCodeableConcept(details?.priority);
    // Encounter.class expects a single Coding
    const encClass = classCC?.coding && classCC.coding.length ? classCC.coding[0] : undefined;
    const priority = priorityCC?.coding ? { coding: priorityCC.coding } : (priorityCC ? { text: priorityCC.text } : undefined);

    // participants could be array of references or strings like "Practitioner/123$#$John Doe"
    const rawParticipants: any[] = actors?.participant || [];
// $#$    // /* alert(JSON.stringify(rawParticipants) */);
    // ["", { "individual": { "reference": "Practitioner/08fc11a0-666d-4f34-b243-a0f70f917971", "display": "Dr. John Doe" } }]
    const participants = (Array.isArray(rawParticipants) ? rawParticipants : [rawParticipants])
      .filter((o) => { return !!o; })
      // .map((p: any) => {
// $#$      //   /* alert(p); */
      //   const ref = this.parseReference(p);
      //   return ref ? { individual: ref } : null;
      // })
      .filter((p): p is { individual: any } => !!p);
// $#$    // /* alert(JSON.stringify(participants) */);

    const authUser = this.authService.user.getValue();
    const practitionerId = authUser?.['fhirResourceId'];
    if (practitionerId) {
      const practitionerRef = `Practitioner/${practitionerId}`;
      const isAlreadyParticipant = participants.some((p: any) => p.individual?.reference === practitionerRef);
      if (!isAlreadyParticipant) {
        participants.push({ individual: { reference: practitionerRef } });
      }
    }

    const encounter: any = {
      resourceType: 'Encounter',
      status: 'in-progress',
      subject: patientRef,
      period: { start: new Date().toISOString() },
      ...(encClass ? { class: encClass } : {}),
      ...(priority ? { priority } : {}),
      ...(participants.length ? { participant: participants } : {})
    };
    console.log('Built Encounter resource:', encounter);
// $#$    // /* debugger; */
    return encounter;
  }

  private conditionClinicalCodeMap = new Set(['active', 'recurrence', 'relapse', 'inactive', 'remission', 'resolved']);
  private conditionVerificationCodeMap = new Set(['unconfirmed', 'provisional', 'differential', 'confirmed', 'refuted', 'entered-in-error']);

  private buildConditionResources(symptomsForm: any, patientId: string, encounterId: string, practitionerRef?: string): any[] {
    const patientRef = { reference: `Patient/${patientId}` };
    const encounterRef = { reference: `Encounter/${encounterId}` };
    const list: any[] = [];
    const arr = symptomsForm?.symptoms || symptomsForm
    for (const row of arr) {
      // if (!row?.code?.code) continue;
      //rewrote the above assuming row.code is a codeableconcept with eother a coding array or text
    const code = row?.code;
if (!code) continue;

const codingArray = Array.isArray(code.coding) ? code.coding : [];
const hasCoding = codingArray.some((c: any) =>
c != null && typeof c.code !== 'undefined' && c.code !== null && String(c.code).trim() !== ''
);
const hasText = typeof code.text === 'string' && code.text.trim() !== '';
if (!hasCoding && !hasText) continue;    
      // const clinical = String(row?.clinicalStatus || '').trim().toLowerCase();
      // const verification = String(row?.verificationStatus || '').trim().toLowerCase();
      // const onset = row?.onsetDateTime ? new Date(row.onsetDateTime).toISOString() : undefined;
      const base: any = {
        resourceType: 'Condition',
        subject: patientRef,
        encounter: encounterRef,
  //*** the codes below were comented out because we assume all the symptonsform.symptoms have already been refined to fhir4 standard */
   
        // code: {
        //   coding: [{ system: row.code.system || 'http://snomed.info/sct', code: row.code.code, display: row.code.display }],
        //   text: row.code.display || row.code.code
        // },
code: row.code,

        /** performing spread to keep absent properties from the payload */
      ...(row?.onsetDateTime ? { onsetDateTime: row.onsetDateTime } : {}),
      //clinical
      ...(row?.clinicalStatus ? { clinicalStatus: row.clinicalStatus } : {}),
      //verification
      ...(row?.verificationStatus ? { verificationStatus: row.verificationStatus } : {}),
      ...(row?.severity ? { severity: row.severity } : {}),
      };
      //*** the codes below were comented out because we assume all the symptonsform.symptoms have already been refined to fhir4 standard */
      // if (this.conditionClinicalCodeMap.has(clinical)) {
      //   base.clinicalStatus = { coding: [{ system: 'http://terminology.hl7.org/CodeSystem/condition-clinical', code: clinical, display: clinical.charAt(0).toUpperCase() + clinical.slice(1) }], text: clinical };
      // } else if (clinical) {
      //   base.clinicalStatus = { text: row.clinicalStatus };
      // }
      // const verificationCode = this.conditionVerificationCodeMap.has(verification) ? verification : 'provisional';
      // base.verificationStatus = { coding: [{ system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status', code: verificationCode, display: verificationCode.charAt(0).toUpperCase() + verificationCode.slice(1) }], text: verificationCode };

      // if (row?.severity) {
      //   base.severity = { text: String(row.severity) };
      // }


      // const isConfirmed = verificationCode === 'confirmed';
      base.asserter =  practitionerRef ? { reference: practitionerRef } : undefined;
      base.recordedDate = new Date().toISOString();

      list.push(base);

      // Clone rule: if confirmed and asserter practitioner, add a provisional patient-stated clone
      // if (isConfirmed && practitionerRef) {
      //   const clone = JSON.parse(JSON.stringify(base));
      //   clone.verificationStatus = { coding: [{ system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status', code: 'provisional', display: 'Provisional' }], text: 'provisional' };
      //   clone.asserter = patientRef;
      //   list.push(clone);
      // }
    }
    return list;
  }

  private parseReference(input: any): { reference: string; display?: string; type?: string } | null {
    if (!input) return null;
    if (typeof input === 'string') {
      const parts = input.split('$#$');
      if (parts.length >= 1) {
        return { reference: parts[0], display: parts[1], type: parts[2] };
      }
      // assume the string is already a FHIR reference
      return { reference: input };
    }
    if (typeof input === 'object' && input.reference) {
      return input as any;
    }
    return null;
  }

  private normalizeServiceRequestReasons(rawReason: any): { reasonReference: Reference[]; reasonCode: CodeableConcept[] } {
    const rows = Array.isArray(rawReason) ? rawReason : [];
    const reasonReference: Reference[] = [];
    const reasonCode: CodeableConcept[] = [];

    for (const row of rows) {
      const normalizedRef = this.normalizeReasonReferenceInput(row?.reasonReference);
      if (normalizedRef) {
        reasonReference.push(normalizedRef);
      }

      const concept = this.utilityService.toCodeableConcept(row?.reasonCode) as CodeableConcept | null;
      if (concept) {
        reasonCode.push(concept);
      }
    }

    return { reasonReference, reasonCode };
  }

  private normalizeReasonReferenceInput(value: any): Reference | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const refFromString = this.utilityService.referenceFromDelimited(value);
      const normalized = refFromString ? { ...refFromString } : { reference: value.trim() };
      return this.ensureReferenceResourcePrefix(normalized);
    }

    if (typeof value === 'object') {
      const rawReference = value.reference ?? value.id ?? value.resourceReference;
      if (!rawReference) {
        return null;
      }

      return this.ensureReferenceResourcePrefix({
        reference: String(rawReference).trim(),
        ...(value.display ? { display: value.display } : {}),
        ...(value.type ? { type: value.type } : {})
      });
    }

    return null;
  }

  private ensureReferenceResourcePrefix(ref: Reference | null): Reference | null {
    if (!ref?.reference) {
      return null;
    }

    const trimmed = ref.reference.trim();
    const reference = trimmed.includes('/') ? trimmed : `Condition/${trimmed}`;

    return {
      ...ref,
      reference
    };
  }

  // Build a FHIR R4 transaction Bundle for Encounter + Conditions + Observations
  private buildEncounterBundle(encounter: any, conditions?: any[], observations?: any[]): any {
    // Assign temporary UUIDs and use urn:uuid references so intra-bundle links resolve
    const encounterUUID = (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e12).toString());
    const encounterFullUrl = `urn:uuid:${encounterUUID}`;
    const encounterEntry = {
      fullUrl: encounterFullUrl,
      resource: encounter,
      request: { method: 'POST', url: 'Encounter' }
    };

    // Ensure all resources reference the bundle Encounter
    const fixRef = (r: any) => {
      if (r && r.encounter && r.encounter.reference && r.encounter.reference.startsWith('Encounter/')) {
        r.encounter.reference = encounterFullUrl;
      }
    };
    // const conditionEntries = (conditions || []).map((c) => {
    //   fixRef(c);
    //   return {
    //     fullUrl: `urn:uuid:${crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e12).toString()}`,
    //     resource: c,
    //     request: { method: 'POST', url: 'Condition' }
    //   };
    // });
    // const observationEntries = (observations || []).map((o) => {
    //   fixRef(o);
    //   return {
    //     fullUrl: `urn:uuid:${crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e12).toString()}`,
    //     resource: o,
    //     request: { method: 'POST', url: 'Observation' }
    //   };
    // });

    // Also ensure the Encounter.subject is a Patient reference (external), leave as-is
    // Performer refs remain as external Practitioner/{id}

    return {
      resourceType: 'Bundle',
      type: 'transaction',
      entry: [encounterEntry]// ...conditionEntries, ...observationEntries]
    };
  }

  // POST the transaction bundle to the FHIR server
  private postEncounterBundle(bundle: any): Observable<any> {
    // NOTE: Replace base URL and headers to match your environment
    const baseUrl = this.backendEndPoint; // e.g., 'https://your-server/fhir'
    return this.http.post(`${baseUrl}`, bundle, {
      headers: { 'Content-Type': 'application/fhir+json', 'Accept': 'application/fhir+json' }
    });
  }

  setEncounterState(patientId: string, encounter: 'planned' | 'in-progress' | 'on-hold' | 'discharged' | 'completed' | 'cancelled' | 'discontinued' | 'entered-in-error' | 'unknown') {
    if (this.globalEncounterState.hasOwnProperty(patientId)) {
      console.log(encounter);
      this.globalEncounterState[patientId].next(encounter);

    } else {
      this.globalEncounterState[patientId] = new BehaviorSubject(encounter);
    }
  }

  getEncounterState(patientId: string): Observable<'planned' | 'in-progress' | 'on-hold' | 'discharged' | 'completed' | 'cancelled' | 'discontinued' | 'entered-in-error' | 'unknown'> {
    if (this.globalEncounterState.hasOwnProperty(patientId)) {

      return this.globalEncounterState[patientId];
      return this.globalEncounterState[patientId];
    } else {
      this.globalEncounterState[patientId] = new BehaviorSubject<'planned' | 'in-progress' | 'on-hold' | 'discharged' | 'completed' | 'cancelled' | 'discontinued' | 'entered-in-error' | 'unknown'>('unknown');

      return this.globalEncounterState[patientId];
    }
  }

  getPatientId() {
    return this.route.snapshot.paramMap.get('patientId') || '';
  }

  router = inject(Router)
  stateService = inject(StateService)

  private isCurrentUserParticipant(encounter: any): boolean {
    const authUser = this.authService.user.getValue();
    const practitionerId = authUser?.['fhirResourceId'];
    if (!encounter?.participant || encounter.participant.length === 0) {
      return true; // legacy data fallback
    }
    return encounter.participant.some((p: any) => 
      practitionerId && p.individual?.reference === `Practitioner/${practitionerId}`
    );
  }

  addEncounter(patientId: string) {
// $#$    // /* alert("added here"); */
// $#$    // /* alert(patientId); */
    // Logic to add an encounter
    console.log('Add Encounter clicked');
    // Check if there is already a current encounter in state
    let currentEncounter: any = null;
    this.stateService.currentEncounter.subscribe(enc => currentEncounter = enc).unsubscribe();
    if (currentEncounter && currentEncounter.status == 'in-progress' && this.isCurrentUserParticipant(currentEncounter)) {
      const startText = currentEncounter?.period?.start
        ? new Date(currentEncounter.period.start).toLocaleString()
        : null;
      const msg = startText
        ? `An encounter is already in progress for this patient (started ${startText}). Use the Tasks button to continue.`
        : `An encounter is already in progress for this patient. Use the Tasks button to continue.`;
      this.sn.openFromComponent(SuccessMessageComponent, {
        data: { message: msg, action: 'Open Tasks' },
        duration: 4000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }

    forkJoin({
      class: this.formFieldsDataService.getFormFieldSelectData('encounter', 'class'),
      priority: this.formFieldsDataService.getFormFieldSelectData('encounter', 'priority'),
      participant: this.formFieldsDataService.getFormFieldSelectData('encounter', 'participant'),
      reason: this.formFieldsDataService.getFormFieldSelectData('encounter', 'reason'),
    }).subscribe((g: any) => {
      console.log(g);
      const dRef = this.dialog.open(EncounterCheckComponent, {
        maxHeight: '90vh',
        maxWidth: '900px',
        autoFocus: false,
        disableClose: true,
        data: {
          requiredVitals: this.requiredVitals,

          formMetaDataToUse: <formMetaData>{
            formName: 'Encounter (Visits)',
            formDescription: "Record your encounter with patient",
            submitText: 'Initiate Encounter',
          },

          formFieldsToUse:
          {
            'details': <FormFields[]>[
              {
                generalProperties: {

                  fieldApiName: 'class',
                  fieldName: 'Type of Encounter',
                  fieldLabel: 'Type of Encounter',
                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false,
                  validations: [
                    { type: 'default', name: 'required' }
                  ]
                },
                data: <codeableConceptDataType>{
                  coding: g.class.concept
                }
              },
              {
                generalProperties: {

                  fieldApiName: 'priority',
                  fieldName: 'Encounter Urgency',
                  fieldLabel: 'Encounter Urgency',
                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false,
                  validations: [
                    { type: 'default', name: 'required' }
                  ]
                },
                data: <codeableConceptDataType>{
                  coding: g.priority.concept
                }
              },
            ],
            'actors': <FormFields[]>[

              {
                generalProperties: {

                  fieldApiName: 'participant',
                  fieldName: 'Participant',
                  fieldLabel: 'People Providing Service',
                  fieldType: 'IndividualReferenceField',
                  isArray: true,
                  isGroup: false,
                  value: g.pa

                },
                data: (g.participant as ReferenceDataType[]).filter((p: ReferenceDataType) => {
                  //get logged in practitoner
                  const loggedInPractitonerId = this.authService.user.getValue()?.fhirResourceId;
                  if (loggedInPractitonerId) {
                    console.log(p?.reference)
                    console.log(loggedInPractitonerId)
                    return !p?.reference?.includes(loggedInPractitonerId)
                  } else {
                    return true
                  }
                  //get is id and remove from list
                })



              }],
            'notes': <FormFields[]>[{
              generalProperties: {

                fieldApiName: 'notes',
                fieldName: 'Other Symptom Details',
                fieldLabel: 'Other Symptom Details',
                fieldType: 'IndividualField',
                inputType: 'textarea',
                isArray: false,
                isGroup: false
              },
              data: ''
            }
            ]
            ,

            // {
            //   generalProperties: {
            //     fieldApiName: 'encounter_reason',
            //     fieldName: 'Reason for Encounter',
            //     fieldLabel: 'Reason for Encounter',
            //     isArray: true,
            //     isGroup: true

            //   },
            //   groupFields: {
            'reason': <FormFields[]>[<CodeableConceptFieldFromBackEnd>{
              generalProperties: {
                fieldApiName: 'reason',
                fieldName: 'Patient Symptom',
                fieldLabel: 'Patient Symptom',
                fieldType: "CodeableConceptFieldFromBackEnd",
                isArray: false,
                isGroup: false,
                allowedOthers: true,
                validations: [
                  { type: 'default', name: 'required' }
                ]
              },
              data: ['https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/condition-code&_format=json'],
            },
            <SingleCodeField>{
              generalProperties: <generalFieldsData>{
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldApiName: 'clinicalStatus',
                fieldName: "Clinical Status",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                fieldLabel: "Whether the symptom is still active",
                fieldPlaceholder: "Whether the symptom is still active",
                value: 'Active',
                isArray: false,
                isGroup: false,

              },
              data: "active | recurrence | relapse | inactive | remission | resolved | unknown".split('|').map((e: string) => e.trim().slice(0, 1).toUpperCase() + e.trim().slice(1))
            },
            <SingleCodeField>{
              generalProperties: <generalFieldsData>{
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldApiName: 'verificationStatus',
                fieldName: "Verification Status",
                fieldType: 'SingleCodeField',
                isHidden: true,
                inputType: 'text',
                fieldLabel: "Is the Symptom Confirmed",
                fieldPlaceholder: "Is the Symptom Confirmed",
                isArray: false,
                isGroup: false,
                value: 'Provisional'
              },
              data: "unconfirmed | provisional | differential | confirmed | refuted | entered-in-error".split('|').map((e: string) => e.trim().slice(0, 1).toUpperCase() + e.trim().slice(1))
            },
            //severity
            <SingleCodeField>{
              generalProperties: <generalFieldsData>{
                auth
                  : {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldApiName: 'severity',
                fieldName: "Severity",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                isArray: false,
                isGroup: false,
              },
              data: "mild | moderate | severe".split(' | ').map((e: string) => e.trim().slice(0, 1).toUpperCase() + e.trim().slice(1))
            },

















            <IndividualField>{
              generalProperties: <generalFieldsData>{
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
                fieldApiName: 'onsetDateTime',
                fieldName: "Onset Date/Time",
                fieldLabel: "When the symptom started",
                fieldPlaceholder: "When the symptom started",
                fieldType: 'IndividualField',
                inputType: 'datetime-local',
                isArray: false,
                isGroup: false,
              },
              data: ""
            }
              // 'encounter_use': <CodeableConceptField>{
              //   generalProperties: {
              //     fieldApiName: 'encounter_reason_use',
              //     fieldName: 'Reason\'s Type',
              //     fieldLabel: 'Reason\'s Type',
              //     fieldType: 'CodeableConceptField',
              //     isArray: false,
              //     isGroup: false
              //   },
              //   data: {
              //     coding: g.reason_use.concept
              //   }
              // }
              // }




              // }

            ]


          }
        }
      })

      dRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result && result.encounterInitiated) {
          // Simulate encounter creation and get an Encounter ID (would be POST in real impl)
          const encounterId = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e12).toString();
          this.setEncounterState(patientId, 'in-progress');

          // Build performer reference from auth user (Practitioner)
          const authUser = this.authService.user.getValue();
          const performerRef = authUser?.['fhirResourceId'] ? `Practitioner/${authUser['fhirResourceId']}` : undefined;

          // Build vitals Observations with encounter and performer references using raw vitals
          // const vitalsObservations = this.buildVitalsObservations(result.vitals || {}, patientId, encounterId, performerRef, new Date().toISOString());
// $#$          // // /* alert(result.actors) */
          // Build Encounter resource from details and actors
          const encounterResource = this.buildEncounterResource(patientId, result.details || {}, result.actors || {});
          // Build Condition resources from symptoms form with clone rule
          // const conditions = this.buildConditionResources(result.symptomsForm || {}, patientId, encounterId, performerRef);

          // Compose a transaction bundle with urn:uuid linking
          const bundle = this.buildEncounterBundle(encounterResource)//, conditions, vitalsObservations);
          console.log('FHIR Transaction Bundle:', bundle);

          // Submit to FHIR server
          this.postEncounterBundle(bundle).subscribe({
            next: (resp) => {
              // Build a server-aligned bundle with assigned ids and fixed references
              const mergedBundle = this.materializeTransactionResponse(bundle, resp);

              // Use the real Encounter (with server id) to seed current encounter
              const encounterResource = this.findResourceInBundle(mergedBundle, 'Encounter');
              if (encounterResource) {
                this.stateService.setCurrentEncounter({
                  patientId,
                  status: encounterResource.status || 'in-progress',
                  ...encounterResource
                });
              }

              console.log('FHIR Transaction Response:', resp);
              this.sn.openFromComponent(SuccessMessageComponent, {
                data: { message: 'Encounter and related records saved' },
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top'
              });

              // Use the merged response (not the pre-post request bundle)
              this.stateService.processBundleTransaction(mergedBundle);

              this.dialog.closeAll();
            },
            error: (err) => {
              console.error('FHIR Transaction Error:', err);
              this.errorService.openandCloseError('Failed to save encounter. Please try again.');
            }
          });
        } else {
          this.errorService.openandCloseError('You did not initiate an encounter before closing the encounter form!.');
        }
      });


    })
    // You can implement the logic to open a dialog or navigate to a form here
  }

  addObservation_former(patientId: string) {
    if (this.globalEncounterState.hasOwnProperty(patientId)
      && this.globalEncounterState[patientId].getValue() == 'in-progress'
    ) {
      forkJoin({

        practitioner: this.http.get("/encounter/encounter_participant.json") as Observable<ReferenceDataType>,
        category: this.http.get("/observation/observation_category.json"),
        code: this.http.get("/observation/observation_code.json"),


      }).pipe(map((all: any) => {
        const keys = Object.keys(all);
        keys.forEach((key) => {
          console.log(all[key]);
          if (all[key].hasOwnProperty('system') && all[key].hasOwnProperty('property')) {
            all[key] = {
              ...all[key], concept: all[key].concept.map((e: any) => {

                const system = all[key].system;
                return { ...e, system }


              })
            }
          } else {
            all[key] = all[key]
          }
        })
        return all;
      })).subscribe((g: any) => {
        console.log(g);
        const dRef = this.dialog.open(DynamicFormsV2Component, {
          maxHeight: '90vh',
          maxWidth: '900px',
          autoFocus: false,
          data: {

            formMetaData: <formMetaData>{
              formName: 'Observations',
              formDescription: "Record your Observations",
              submitText: 'Submit Observation',
            },
            formFields: <FormFields[]>[
              {

                generalProperties: {

                  fieldApiName: 'category',
                  fieldName: 'Observation Category',
                  fieldLabel: 'Observation Category',

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: <codeableConceptDataType>{
                  coding: g.category.concept
                }
                ,
              },

              {

                generalProperties: {

                  fieldApiName: 'name',
                  fieldName: 'Name of Observation',
                  fieldLabel: 'Name of Observation',

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: <codeableConceptDataType>{
                  coding: g.code.concept
                }
                ,
              },
              <SingleCodeField>{

                generalProperties: {

                  fieldApiName: 'status',
                  fieldName: 'Observation\'s Status',
                  fieldLabel: 'Observation\'s Status',

                  fieldType: 'SingleCodeField',
                  isArray: false,
                  isGroup: false
                },
                data: this.observation_status
                ,
              },
              <GroupField>{
                groupFields: {
                  'result_type': <SingleCodeField>{

                    generalProperties: {

                      fieldApiName: 'result_type',
                      fieldName: 'Type of Result',
                      fieldLabel: 'Type of Result',

                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: false
                    },
                    data: ['Number', 'Text']

                  },
                  'result_value': <IndividualField>{
                    generalProperties: {

                      fieldApiName: 'result_value',
                      fieldName: 'Result Value',
                      fieldLabel: 'Result Value',

                      fieldType: 'IndividualField',
                      isArray: false,
                      isGroup: false
                    },


                  },

                  'result_unit': <IndividualField>{

                    generalProperties: {

                      fieldApiName: 'result_unit',
                      fieldName: 'Unit',
                      fieldLabel: 'Unit',

                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: false
                    },
                    data: this.observation_units

                  },


                },
                keys: [
                  ''
                ],
                generalProperties: {

                  fieldApiName: 'value',
                  fieldName: 'Observation / Tests Results',
                  fieldLabel: 'Observation / Tests Results',
                  fieldType: 'SingleCodeField',
                  isArray: false,
                  isGroup: true
                },


              },

              <GroupField>{
                groupFields: {
                  'result_type': <SingleCodeField>{

                    generalProperties: {

                      fieldApiName: 'result_type',
                      fieldName: 'Type',
                      fieldLabel: 'Type',

                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: false
                    },
                    data: ['Numbers', 'words']

                  },
                  'result_value': <IndividualField>{
                    generalProperties: {

                      fieldApiName: 'result_value',
                      fieldName: 'Value',
                      fieldLabel: ' Value',

                      fieldType: 'IndividualField',
                      isArray: false,
                      isGroup: false
                    },


                  },

                  'result_unit': <IndividualField>{

                    generalProperties: {

                      fieldApiName: 'result_unit',
                      fieldName: 'Unit',
                      fieldLabel: 'Unit',

                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: false
                    },
                    data: this.observation_units

                  },


                },
                keys: [
                  ''
                ],
                generalProperties: {

                  fieldApiName: 'Normal Range',
                  fieldName: 'Normal Test  Range',
                  fieldLabel: 'Normal Test Range',
                  fieldType: 'SingleCodeField',
                  isArray: false,
                  isGroup: true
                },


              },
            ]
          }
        })
      })
    } else {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
    }

  }
























  addObservation(patientId: string, observationCategory: string | null = null, incomingDref: MatDialogRef<any> | null = null, ObsCat: string | null = null) {
    if (!this.stateService.isEncounterActive()) {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
      return;
    }

    let category = 'category'
    if (observationCategory) {
      switch (observationCategory) {
        case 'vitalSigns-exam':
          category = 'category2';
          break;
        case 'exam':
          category = 'category3'
          break;
        case 'lab-test':
          category = 'category4'
          break;
        default:
          break;


      }
    }
    if (
      (
        (category === 'category2' || category === 'category3') &&
        this.globalEncounterState.hasOwnProperty(patientId)
        && this.globalEncounterState[patientId].getValue() == 'in-progress'
      ) || (category !== 'category2' && category !== 'category3')
    ) {
      forkJoin({
        practitioner: this.formFieldsDataService.getFormFieldSelectData('observation', 'practitioner'),
        category2: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        category3: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        category4: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        category: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        code: this.formFieldsDataService.getFormFieldSelectData('observation', 'ontoServerCode'),
      }).subscribe((g: any) => {

// $#$        // /* alert(JSON.stringify(g.code) */);
        console.log(g.category);
        const toSpreadObj: any = {
          maxHeight: '90vh',
          maxWidth: '650px',
          autoFocus: false,
          data: {
            isAnyCategory: false,
            obsCategory: ObsCat,
            observationformFields: [

              ['category', {
                formFields:
                  <FormFields[]>[
                    {
                      generalProperties: {
                        fieldApiName: 'category',
                        fieldName: 'Observation / Test Category',
                        fieldLabel: 'Observation / Test Category',
                        fieldType: 'CodeableConceptField',
                        isArray: false,
                        isGroup: false
                      },
                      data: <codeableConceptDataType>{
                        coding: g[category].filter((c: any) => {
                          if (typeof c === 'string' && c.split('$#$').length >= 3) {
                            const code = c.split('$#$')[0];
                            return code !== 'vital-signs' && code !== 'exam'

                          } else {
                            if (typeof c === 'object' && c.code) {
                              return c.code !== 'vital-signs' && c.code !== 'exam'
                            } else {
                              return true;
                            }
                          }
                        })
                      },
                    },
                  ]
              }],
              ['status', {
                formFields: [
                  <SingleCodeField>{
                    generalProperties: {
                      fieldApiName: 'status',
                      fieldName: 'Observation Status',
                      fieldLabel: 'Observation Status',
                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: false,
                      value: 'final',
                      validations: [{ type: 'default', name: 'required' }]
                    },
                    data: ['preliminary', 'final']
                  }
                ] as FormFields[]
              }],
              ['name', {
                formFields:
                  <FormFields[]>[
                    {
                      generalProperties: {
                        fieldApiName: 'name',
                        fieldName: 'Name of Observation / Test',
                        fieldHint: 'Pick from suggested names or enter your own',
                        fieldLabel: 'Name of Observation / Test',
                        allowedOthers: true,
                        fieldType: 'CodeableConceptFieldFromBackEnd',
                        isArray: false,
                        isGroup: false
                      },
                      data: g.code
                    },
                  ]
              }],
              ['value', {
                formFields: [
                  <GroupField>{


                    groupFields: {
                      'result_type': <SingleCodeField>{

                        generalProperties: {

                          fieldApiName: 'result_type',
                          fieldName: 'Type of Result',
                          fieldLabel: 'Type of Result',
                          // value: category === "category3" ? 'Text' : '',
                          controllingField: [{
                            isAControlField: true,
                            dependentFieldVisibilityTriggerValue: 'Text',
                            controlledFieldDependencyId: "result_type.text"

                          },
                          {
                            isAControlField: true,
                            dependentFieldVisibilityTriggerValue: 'Number',
                            controlledFieldDependencyId: "result_type.number2"

                          },

                          {
                            isAControlField: true,
                            controlledFieldDependencyId: "result_type.number",
                            dependentFieldVisibilityTriggerValue: 'Number'
                          }],
                          fieldType: 'SingleCodeField',
                          isArray: false,
                          isGroup: false
                        },
                        data: ['Number', 'Text']

                      },
                      'result_value': <IndividualField>{
                        generalProperties: {

                          fieldApiName: 'result_value',
                          fieldName: 'Result Value',
                          fieldLabel: 'Result Value',
                          inputType: 'number',
                          dependence_id: 'result_type.number',
                          fieldType: 'IndividualField',
                          isArray: false,
                          isGroup: false
                        },


                      },

                      'result_value_text': <IndividualField>{
                        generalProperties: {

                          fieldApiName: 'result_value',
                          fieldName: 'Result ',
                          fieldLabel: 'Result ',
                          inputType: 'textarea',
                          dependence_id: 'result_type.text',
                          fieldType: 'IndividualField',
                          isArray: false,
                          isGroup: false
                        },


                      },

                      'result_unit': <IndividualField>{

                        generalProperties: {

                          fieldApiName: 'result_unit',
                          fieldName: 'Unit',
                          fieldLabel: 'Unit',
                          fieldHint: 'Pick from suggested units or enter your own',
                          dependence_id: 'result_type.number2',
                          fieldType: 'SingleCodeField',
                          isArray: false,
                          isGroup: false
                        },
                        data: this.observation_units

                      },


                    },
                    keys: [
                      ''
                    ],
                    generalProperties: {

                      fieldApiName: 'value',
                      fieldName: category === "category3" ? 'Observation Results' : 'Observation / Test Results',
                      fieldLabel: category === "category3" ? 'Observation Results' : 'Observation / Test Results',
                      fieldType: 'SingleCodeField',
                      isArray: false,
                      isGroup: true
                    },


                  },
                ]
              }],

              [
                'attachment', {
                  formFields: [
                    <IndividualField>{
                      generalProperties: {

                        fieldApiName: 'attachment',
                        fieldName: 'Add an Attachment',
                        fieldLabel: 'Add an Attachment',
                        fieldType: 'IndividualField',
                        isArray: false,
                        isGroup: false,
                        inputType: 'photo_upload'
                      },
                      data: ''
                    },

                  ]
                }
              ]]
              .filter((ff: any) => {
                if (category !== 'category' && ff[0] === 'category') {
                  return false;
                }


                return true;
              })
          }



        }

        if (incomingDref) {
          incomingDref.close();
          incomingDref.afterClosed().subscribe(() => {
// $#$            // /* alert("i am closed"); */
            this.dialog.open(AddObservationComponent, {
              ...toSpreadObj
            });
          });
        } else {

          this.dialog.open(AddObservationComponent, {
            ...toSpreadObj
          });
        }
// $#$        // /* alert(toSpreadObj.data.observationformFields.name.) */


      })
    } else {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
    }
  }





















































  addAnotherFormerObservation(patientId: string, observationCategory: string | null = null) {
    let category = 'category'
    if (observationCategory) {
      switch (observationCategory) {
        case 'vitalSigns-exam':
          category = 'category2';
          break;
        case 'exam':
          category = 'category3'
          break;
        default:
          break;


      }
    }
    if (this.globalEncounterState.hasOwnProperty(patientId)
      && this.globalEncounterState[patientId].getValue() == 'in-progress'
    ) {
      forkJoin({
        practitioner: this.formFieldsDataService.getFormFieldSelectData('observation', 'practitioner'),
        category2: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        category3: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        category: this.formFieldsDataService.getFormFieldSelectData('observation', category),
        code: this.formFieldsDataService.getFormFieldSelectData('observation', 'ontoServerCode'),
      }).subscribe((g: any) => {
        console.log(g);
        const dRef = this.dialog.open(AddObservationComponent, {
          maxHeight: '90vh',
          maxWidth: '650px',
          autoFocus: false,
          data: {
            observationformFields: [[
              'category', {
                formFields:
                  <FormFields[]>[
                    {

                      generalProperties: {

                        fieldApiName: 'category',
                        fieldName: 'Observation Category',
                        fieldLabel: 'Observation Category',

                        fieldType: 'CodeableConceptField',
                        isArray: false,
                        isGroup: false
                      },
                      data: <codeableConceptDataType>{
                        coding: g[category]['concept']
                      }
                      ,
                    },

                  ]
              }],
            ['name',
              {
                formFields:
                  <FormFields[]>[
                    {

                      generalProperties: {

                        fieldApiName: 'name',
                        fieldName: 'Name of Observation',
                        fieldLabel: 'Name of Observation',

                        fieldType: 'CodeableConceptField',
                        isArray: false,
                        isGroup: false
                      },
                      data: <codeableConceptDataType>{
                        coding: g.code.concept
                      }
                      ,
                    },
                  ]

              }],
            ['value', {
              formFields: [
                <GroupField>{
                  groupFields: {
                    'result_type': <SingleCodeField>{

                      generalProperties: {

                        fieldApiName: 'result_type',
                        fieldName: 'Type of Result',
                        fieldLabel: 'Type of Result',

                        fieldType: 'SingleCodeField',
                        isArray: false,
                        isGroup: false
                      },
                      data: ['Number', 'Text']

                    },
                    'result_value': <IndividualField>{
                      generalProperties: {

                        fieldApiName: 'result_value',
                        fieldName: 'Result Value',
                        fieldLabel: 'Result Value',

                        fieldType: 'IndividualField',
                        isArray: false,
                        isGroup: false
                      },


                    },

                    'result_unit': <IndividualField>{

                      generalProperties: {

                        fieldApiName: 'result_unit',
                        fieldName: 'Unit',
                        fieldLabel: 'Unit',

                        fieldType: 'SingleCodeField',
                        isArray: false,
                        isGroup: false
                      },
                      data: this.observation_units

                    },


                  },
                  keys: [
                    ''
                  ],
                  generalProperties: {

                    fieldApiName: 'value',
                    fieldName: 'Observation / Test Results',
                    fieldLabel: 'Observation / Test Results',
                    fieldType: 'SingleCodeField',
                    isArray: false,
                    isGroup: true
                  },


                },
              ]
            }]
            ]
          }

        });
      })
    } else {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
    }
  }

  addDiagnosis(patientId: string) {
    if (this.encounterStateCheck(patientId)) {

    }
  }


  addSpecimen(patientId?: string, serviceRequestId?: string) {
    forkJoin({
      status: this.formFieldsDataService.getFormFieldSelectData('specimen', 'status'),
      type: this.formFieldsDataService.getFormFieldSelectData('specimen', 'type'),
      condition: this.formFieldsDataService.getFormFieldSelectData('specimen', 'condition'),
      bodySite: this.formFieldsDataService.getFormFieldSelectData('specimen', 'bodySite'),
      subject: this.formFieldsDataService.getFormFieldSelectData('specimen', 'subject'),
      request: this.formFieldsDataService.getFormFieldSelectData('specimen', 'request'),
      // code: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'code'),
      // performerType: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'performerType'),
      // priority: this.formFieldsDataService.getFormFieldSelectData('serviceRequest', 'priority'),
    }).subscribe({
      next: (g: any) => {

        const dRef = this.dialog.open(DynamicFormsV2Component, {
          maxHeight: '90vh',
          maxWidth: '650px',
          autoFocus: false,
          data: {
            formMetaData: <formMetaData>{
              formName: 'Specimen Record ',
              formDescription: "Use this form to record specimens for a specific lab test",
              submitText: 'Submit Request',
            },
            formFields: <FormFields[]>[
              {
                generalProperties: {

                  fieldApiName: 'status',
                  fieldName: 'Status of Specimen',
                  fieldLabel: 'Status of Specimen',
                  value: 'Availabe',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'SingleCodeField',
                  isArray: false,
                  isGroup: false
                },
                data: "available | unavailable | unsatisfactory | entered-in-error".split('|').map((e: string) => e.trim().slice(0, 1).toUpperCase() + e.trim().slice(1))

              }, {
                generalProperties: {

                  fieldApiName: 'type',
                  fieldName: 'Specimen Type',
                  fieldLabel: 'Specimen Type',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.type

              },
              //subject
              {
                generalProperties: {
                  fieldApiName: 'subject',
                  fieldName: 'Who Specimen is from',
                  fieldLabel: 'Who Specimen is from',
                  value: patientId ? "Patient/" + patientId : "",
                  isHidden: patientId ? true : false,
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldType: 'IndividualReferenceField',
                  isArray: false,
                  isGroup: false
                },
                data: g.subject
              },
              {
                generalProperties: {
                  fieldApiName: 'request',
                  fieldName: 'Referenced Lab Test Request ',
                  fieldLabel: 'Referenced Lab Test Request ',
                  moreHint: "Lab request for which this specimen is intended",
                  value: serviceRequestId ? "ServiceRequest/" + serviceRequestId : "",
                  isHidden: serviceRequestId ? true : false,

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldType: 'IndividualReferenceField',
                  isArray: false,
                  isGroup: false
                },
                data: g.request
              },
              {
                generalProperties: {

                  fieldApiName: 'receivedTime',
                  fieldName: 'Received Date',
                  fieldLabel: 'Received Date',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  inputType: 'datetime-local',
                  isArray: false,
                  isGroup: false
                },


              },
              <IndividualField>{
                generalProperties: {
                  fieldApiName: 'receivedTimeTime',
                  fieldName: 'Received Time',
                  fieldLabel: 'Received Time',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  inputType: 'time',
                  isArray: false,
                  isGroup: false
                }
              },
              //collection.collectedDateTime

              //collection.collector

              {
                generalProperties: {

                  fieldApiName: 'condition',
                  fieldName: 'Specimen Condition',
                  fieldLabel: 'Specimen Condition',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },


                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.condition


              },
              {
                generalProperties: {

                  fieldApiName: 'bodySite',
                  fieldName: 'Body Collection Site',
                  fieldLabel: 'Body Collection Site',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },


                  fieldType: 'CodeableConceptFieldFromBackEnd',
                  isArray: false,
                  isGroup: false
                },
                data: g.bodySite


              },
              {
                generalProperties: {

                  fieldApiName: 'note',
                  fieldName: 'Additional Notes',
                  fieldLabel: 'Additional Notes',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  inputType: 'textarea',
                  isArray: false,
                  isGroup: false
                },

              }
            ]
          }
        })
      },
      error: (err: any) => {
        this.errorService.openandCloseError("An error ocurred while fetching specimen data");
      }
    });

  }
  /**
   * Add service request for patient
   * @param patientId - Patient ID
   * @param encounterId - Optional encounter ID
   * @param returnServiceRequestId - Callback to return created service request ID (optional)
   */
  addServiceRequest(
    patientId: string | null,
    typeOfService: string | null = null,
    returnServiceRequestId: boolean = false,
    generateInvoice: boolean = true
  ) {
    if (!patientId && !this.stateService.currentPatientId$.getValue()) {
      this.errorService.openandCloseError("Please access this feature from within a patient's wrapper/dashboard to establish patient context.");
      return;
    }

    // return early if there is no encounter
    console.log(this.stateService.currentEncounter.getValue()
    );
// $#$    // /* debugger; */
    if (this.stateService.isEncounterActive() === false || !this.stateService.currentEncounter.getValue()) {
      this.errorService.openandCloseError("You need to initiate an encounter before a service request can be added for this patient");
      // if (returnServiceRequestId) return null;
      // return;
    }
    // no p


    of({}).subscribe({
      next: (g: any) => {
        console.log(g.medication);
        const mapIntentToStatus = new Map<string, string>([
          ['proposal', 'draft'],
          ['plan', 'draft'],
          ['order', 'active'],
          ['option', 'active']
        ]);
        const dRef = this.dialog.open(AddLabRequestsComponent, {
          maxHeight: '90vh',
          maxWidth: typeOfService && String(typeOfService).toLowerCase().includes('lab') ? '900px' : '630px',
          autoFocus: false,
          data: {
            typeOfService: typeOfService,
            formMetaData: <formMetaData>{
              formName: typeOfService ? `${typeOfService} Service Request` : 'Service Request (Lab Tests, e.t.c.)',
              formDescription: "Use this form to order a " + (typeOfService ? typeOfService : "lab test") + " or any other medical services from your department or others",
              submitText: 'Submit Request',
            },
            formFields: <FormFields[]>[
              {

                generalProperties: {

                  fieldApiName: 'status',
                  fieldName: 'Status of Request',
                  fieldLabel: 'Status of Request',
                  value: 'active',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.status

              },
              {

                generalProperties: {

                  fieldApiName: 'intent',
                  fieldName: 'Intent of the Request',
                  fieldLabel: 'Intent of the Request',
                  value: 'order',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.intent

              },
              {

                generalProperties: {

                  fieldApiName: 'code',
                  fieldName: 'Service Requested',
                  fieldLabel: 'Service Requested',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptFieldFromBackEnd',
                  isArray: true,
                  isGroup: false
                },
                data: g.code
              },
              {

                generalProperties: {

                  fieldApiName: 'performerType',
                  fieldName: 'Pratitioner Required',
                  fieldLabel: 'Practitioner Required',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.performerType
              },
              {

                generalProperties: {

                  fieldApiName: 'priority',
                  fieldName: 'Priority',
                  fieldLabel: 'Priority',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  fieldType: 'CodeableConceptField',
                  isArray: false,
                  isGroup: false
                },
                data: g.priority
              },
              {

                generalProperties: {

                  fieldApiName: 'orderDetailParameterValueString',
                  fieldName: 'Additional Details',
                  fieldLabel: 'Additional Details',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  inputType: 'textarea',
                  isArray: false,
                  isGroup: false
                },
                data: g.priority
              },



            ]
          }
        });


        dRef.afterClosed().subscribe((values) => {
// $#$          // /* alert("i am closed"); */
          console.log('Dialog closed with values:', values);
          if (!values) {
            this.errorService.openandCloseError('No Service Request was created as the form was closed without submission.');

          }
          const requisition = this.utilityService.generateRequisition({
            prefix: 'REQ',
            resourceType: 'lab',
            system: `${this.backendEndPoint}`

          })
          values = values.values ? values.values : values;
          let serviceRequestBundle: any = [];
          console.log('Service Request dialog closed');
          console.log(values);
          const isReturnedValueAnArray = Array.isArray(values);
          if (isReturnedValueAnArray) {
            console.log('The returned value is an array.');
          } else {
            console.log('The returned value is not an array.');
          }
          const Invoices: Invoice[] = [];
          const chargeItems: ChargeItem[] = [];

          if (!isReturnedValueAnArray) {
            values = [values];

          }
          serviceRequestBundle = values.map((val: any) => {
            if (val.category && !Array.isArray(val.category)) {
              val = { ...val, category: [val.category] };
            }
            if (val.note) {
              if (!Array.isArray(val.note)) {
                val.note = [val.note];
              }
            }
            if (val.note) {
              val.note = val.note.map((n: any) => {
                if (typeof n === 'string') {
                  return { text: n };
                } else {
                  return n;
                }
              });
            }
            if (val.reason) {
              const { reasonReference, reasonCode } = this.normalizeServiceRequestReasons(val.reason);
              if (reasonReference.length) {
                const existingRefs = Array.isArray(val.reasonReference) ? val.reasonReference : [];
                val.reasonReference = [...existingRefs, ...reasonReference];
              }
              if (reasonCode.length) {
                const existingCodes = Array.isArray(val.reasonCode) ? val.reasonCode : [];
                val.reasonCode = [...existingCodes, ...reasonCode];
              }
              delete val.reason;
            }
            if (!val.category || !val.category.length || val.category.length === 0) {
              val = { ...val, category: [{ text: typeOfService ? typeOfService : "General" }] };
            }
            if (val.code.hasOwnProperty('active') === true) {
              val.isActive = val.code.active;
            } else {
              val.isActive = val.code.isActive
            }
            if (val.code?.code) {
              val.code = {
                code: val.code.code,
                display: val.code.display,
                system: val.code.system
              }
            } else if (val.code?.text) {
              val.code = {
                text: val.code.text
              }
            } else {
              val.code = typeof val.code === 'string' ? { text: val.code } : val.code;
            }
            val.status = mapIntentToStatus.get(val.intent) as ServiceRequest['status'] || 'active';
            console.log(val);
            return {
              ...this.fhirTransformService.transformValues('ServiceRequest', val),
              requester: {
                reference: `Practitioner/${this.authService.user.getValue()?.['fhirResourceId']}`
              },
              subject: {
                reference: `Patient/${this.stateService.currentEncounter.getValue()?.['patientId']}`
              },
              encounter: {
                reference: `Encounter/${this.stateService.currentEncounter.getValue()?.['id']}`
              },
              requisition: requisition,
              resourceType: 'ServiceRequest',
              authoredOn: new Date().toISOString(),

            }
          });
          if (serviceRequestBundle && serviceRequestBundle.length > 0) {
            for (const sr of serviceRequestBundle) {
              if (!sr.performerType) {
                delete sr.performerType;
              }
              //note also
              if (!sr.note) {
                delete sr.note;
              }
            }
          }
          console.log('Transformed Service Request Bundle:', serviceRequestBundle);
          // }
// $#$          // /* debugger */

          // Build transaction bundle.
          // If generateInvoice is true, attach ChargeItem + Invoice entries for each ServiceRequest (when a ChargeItemDefinition exists).
          // Give each new ServiceRequest a local fullUrl so other resources in the same
          // transaction can reference it (basedOn, etc.).
          const makeUrnUuid = () => {
            try {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const anyCrypto: any = (globalThis as any)?.crypto;
              const id = anyCrypto?.randomUUID?.();
              return `urn:uuid:${id || Math.random().toString(16).slice(2)}`;
            } catch {
              return `urn:uuid:${Math.random().toString(16).slice(2)}`;
            }
          };

          const serviceRequestWithFullUrl = (serviceRequestBundle || []).map((resource: any) => {
            // NOTE: `isActive` is a UI/helper flag and must never be posted to FHIR.
            // We keep it only on the wrapper object for local decision-making.


            return {
              resource,
              fullUrl: makeUrnUuid(),

            };
          });

          const serviceRequestEntries = serviceRequestWithFullUrl.map((x: any) => ({
            fullUrl: x.fullUrl,
            resource: x.resource,
            request: {
              method: x.resource.id ? 'PUT' : 'POST',
              url: x.resource.id ? `ServiceRequest/${x.resource.id}` : 'ServiceRequest'
            }
          }));

          const buildAndPost = (extraEntries: any[] = []) => {
            console.log('Preparing to post Service Request Bundle with extra entries:', serviceRequestEntries, extraEntries);
// $#$            // /* debugger; */
// $#$            // /* alert('building and posting'); */
            const fhirBundle = {
              resourceType: 'Bundle',
              type: 'transaction',
              entry: [...serviceRequestEntries, ...extraEntries]
            } as Bundle<any>;

            this.fhirResourceService.postBundle(fhirBundle).subscribe({
              next: (res: any) => {
                console.log('Service Request Bundle posted successfully:', res);
                console.log('========== FULL SERVER RESPONSE DEBUG ==========');
                console.log('Ã°Å¸â€œÂ¦ Full res object:', res);
                console.log('Ã°Å¸â€œÂ¦ res.bundle:', res?.bundle);
                console.log('Ã°Å¸â€œÂ¦ res.bundle type:', res?.bundle?.type);
                console.log('Ã°Å¸â€œÂ¦ Number of entries:', res?.bundle?.entry?.length);
                const responseBundle = res?.bundle || res;
                const responseHeaders = res?.headers; // Ã¢Å“â€¦ Get headers from response

                if (responseBundle?.entry && Array.isArray(responseBundle.entry)) {
                  responseBundle.entry.forEach((entry: any, index: number) => {
                    if (entry.resource && entry.resource.resourceType === 'ServiceRequest') {
                      const persistedServiceRequest = entry.resource;
                      const originalRequestData = values[index] || {};

                      // Ã¢Å“â€¦ Multi-strategy ID extraction
                      let serviceRequestId: string | null = persistedServiceRequest.id;

                      // Strategy 1: Direct from resource.id
                      if (serviceRequestId) {
                        console.log('Ã¢Å“â€¦ Got ID from resource.id:', serviceRequestId);
                      }

                      // Strategy 2: Extract from entry.response.location
                      if (!serviceRequestId && entry.response?.location) {
                        const locationUrl = entry.response.location;
                        console.log('Ã°Å¸â€œÂ Entry location URL:', locationUrl);
                        const match = locationUrl.match(/ServiceRequest\/([^\/\?#_]+)/);
                        serviceRequestId = match ? match[1] : null;
                        if (serviceRequestId) {
                          console.log('Ã¢Å“â€¦ Extracted ID from entry.response.location:', serviceRequestId);
                        }
                      }

                      // Strategy 3: Try fullUrl if it's not a urn:uuid
                      if (!serviceRequestId && entry.fullUrl && !entry.fullUrl.startsWith('urn:uuid:')) {
                        const match = entry.fullUrl.match(/ServiceRequest\/([^\/\?#_]+)/);
                        serviceRequestId = match ? match[1] : null;
                        if (serviceRequestId) {
                          console.log('Ã¢Å“â€¦ Extracted ID from fullUrl:', serviceRequestId);
                        }
                      }

                      // Strategy 4: Check HTTP Location header (for single resource responses)
                      if (!serviceRequestId && responseHeaders) {
                        const locationHeader = responseHeaders.get('Location');
                        if (locationHeader) {
                          console.log('Ã°Å¸â€œÂ HTTP Location header:', locationHeader);
                          const match = locationHeader.match(/ServiceRequest\/([^\/\?#_]+)/);
                          serviceRequestId = match ? match[1] : null;
                          if (serviceRequestId) {
                            console.log('Ã¢Å“â€¦ Extracted ID from HTTP Location header:', serviceRequestId);
                          }
                        }
                      }

                      console.log('Ã°Å¸Å½Â¯ Final ServiceRequest ID:', serviceRequestId);
                      console.log('Ã°Å¸â€œâ€¹ Original request data:', originalRequestData);

                      if (serviceRequestId) {
                        // Create the full ServiceRequest object with the ID
                        const fullServiceRequest = {
                          ...persistedServiceRequest,
                          id: serviceRequestId
                        };

                        this.notifyServiceRequestCreated(
                          fullServiceRequest,
                          originalRequestData
                        );
                      } else {
                        console.error('Ã¢ÂÅ’ ServiceRequest has no ID after all extraction attempts, skipping notification');
                        console.error('Entry structure:', JSON.stringify(entry, null, 2));
                        console.error('Response headers:', responseHeaders);
                      }
                    }
                  });
                } else {
                  console.warn('Ã¢Å¡Â Ã¯Â¸Â Response bundle has unexpected structure:', responseBundle);
                }

                // CORRECTED: Extract ID from the wrapped response
                // if (returnServiceRequestId) {
                //   // Access the bundle from the wrapper object
                //   const responseBundle = res?.bundle || res;

                //   // Try multiple extraction strategies
                //   let serviceRequestId: string | null = null;

                //   // Strategy 1: Extract from response.location header
                //   if (responseBundle?.entry?.[0]?.response?.location) {
                //     const locationUrl = responseBundle.entry[0].response.location;
                //     const idMatch = locationUrl.match(/ServiceRequest\/([^\/\?]+)/);
                //     serviceRequestId = idMatch ? idMatch[1] : null;
                //   }

                //   // Strategy 2: Extract from returned resource.id
                //   if (!serviceRequestId && responseBundle?.entry?.[0]?.resource?.id) {
                //     serviceRequestId = responseBundle.entry[0].resource.id;
                //   }

                //   console.log('Extracted Service Request ID:', serviceRequestId);

                //   if (serviceRequestId) {
                //     // Successfully extracted ID - can be used for linking
                //     // return { reference: `ServiceRequest/${serviceRequestId}` }//, id: serviceRequestId };
                //   } else {
                //     console.warn('Could not extract Service Request ID from response');

                //   }
                // } else {

                // }

                //SUCCESSMESSAGE SNACKBAR
                const successMessage = typeOfService ? `${typeOfService} Request created successfully.` : 'Service Request created successfully.';
                this.snackBar.openFromComponent(SuccessMessageComponent, {
                  data: successMessage,
                  duration: 3000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                });
                // TRIGGER REFRESH
                this.resourceRefresh.notify('ServiceRequest', { full: true });
              },

              error: (err: any) => {
                console.error('Error posting Service Request Bundle:', err);
                this.errorService.openandCloseError(`Error creating ${typeOfService ? typeOfService : "Service"} Request(s). Please try again later.`);
                // if (returnServiceRequestId) return null;
                // return null;
              }
            });
          };

          if (!generateInvoice) {
// $#$            // /* debugger; */
            serviceRequestEntries.forEach((x: any) => {
              delete (x.resource.isActive);
            });
            buildAndPost();
            return;
          }

          (forkJoin(
            (serviceRequestWithFullUrl || []).map((x: any) => {
              const sr = x.resource;
              console.log(sr);
              const isActive = x.isActive !== false;
              delete (x.resource.isActive);
              
              if (!isActive || sr.status !== 'active') {
                return of({});
              }
// $#$              // /* alert(x.resource.code.coding[0].code); */
              return this.utilityService.getServiceRequestCategoryForCode(x.resource?.code?.coding?.[0]?.code || '').pipe(
                switchMap((category) => {
                  if (!category) {
                    //code is not active
                    console.log('not active');
                    // buildAndPost();
// $#$                    // /* debugger; */
                    return of({});


                  } else {
                    console.log('active');
// $#$                    // /* debugger; */

                    return this.prepareChargeItemAndInvoiceForServiceRequest(sr as any, x.fullUrl).pipe(
                      catchError(() => of(null))

                    )
                  }

                }));


            }) as any
          ) as Observable<any[]>).subscribe((results: any[]) => {

            const extraEntries = ((results || []) as any[])
              .filter(Boolean).filter(r => {
// $#$                // /* alert(JSON.stringify(r) */);
                // console.log(r);
// $#$                // /* debugger; */
                return Object.keys(r).length > 0;
              })
              .flatMap((r: any) => {
// $#$                // /* alert(JSON.stringify(r) */);
// $#$                // /* debugger */
                const svc = (r.serviceEntries || []) as any[];
                return [
                  ...svc.map((e: any) => ({
                    fullUrl: e.fullUrl,
                    resource: e.resource,
                    request: e.request
                  })),
                  {
                    fullUrl: r.chargeItemEntry.fullUrl,
                    resource: r.chargeItemEntry.resource,
                    request: r.chargeItemEntry.request
                  },
                  {
                    fullUrl: r.invoiceEntry.fullUrl,
                    resource: r.invoiceEntry.resource,
                    request: r.invoiceEntry.request
                  }
                ];
              });

            buildAndPost(extraEntries);
          });

        });

      },
      error: (err: any) => {
        console.error('Error fetching medication data:', err);

        this.errorService.openandCloseError('Error fetching medication data. Please try again later.');
        // if (returnServiceRequestId) return null;
        // return null;
      }
    })

    // } else {
    //   this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");

    // }
  }
  snackBar = inject(MatSnackBar)
  fhirTransformService = inject(FhirResourceTransformService);
  fhirResourceService = inject(FhirResourceService);
  state = inject(StateService);
  encounterStateCheck(patientId: string) {
    if (this.state.currentEncounter.getValue()
      && this.state.currentEncounter.getValue()?.['patientId'] == patientId
      && (this.state.currentEncounter.getValue()?.status == 'in-progress' ||
        this.state.currentEncounter.getValue()?.status == 'planned')


    ) {
      return true;

    } else {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
      return false;
    }
  }

  addDiagnosisV2() {
    //is there an encounter in progress for the patient?
    if (this.state.isEncounterActive() == false) {
      this.errorService.openandCloseError("You need to initiate an encounter before adding a diagnosis for this patient");
      return;
    }

    const patientId = this.state.currentEncounter.getValue()?.patientId;
    if (!patientId) {
      this.errorService.openandCloseError("Patient ID is missing in the current encounter. Please re-initiate the encounter.");
      return;
    }


    forkJoin({
      code: this.formFieldsDataService.getFormFieldSelectData('condition', 'code'),
      verificationStatus: this.formFieldsDataService.getFormFieldSelectData('condition', 'verificationStatus'),
      clinicalStatus: this.formFieldsDataService.getFormFieldSelectData('condition', 'clinicalStatus'),
      severity: this.formFieldsDataService.getFormFieldSelectData('condition', 'severity'),
      //ce.getFormFieldSelectData('medication', 'reason'),
    }).subscribe({
      next: (g: any) => {
        const authUser = this.authService.user.getValue();
        const performerRef = authUser?.['fhirResourceId'] ? `Practitioner/${authUser['fhirResourceId']}` : undefined;
        const dRef = this.dialog.open(DynamicFormsV2Component, {
          maxHeight: '90vh',
          maxWidth: '650px',
          autoFocus: false,
          data: {

            formMetaData: <formMetaData>{
              formName: 'Diagnosis Form',
              formDescription: "Use this form to enter a diagnosis for the patient. You can request A.I. assistance using the side chat",
              submitText: 'Confirm Diagnosis',
              closeDialogOnSubmit: true,
            },
            formFields: <FormFields[]>[
              // verificationStatus - unconfirmed | provisional | differential | confirmed | refuted | entered-in-error
              //clinicalStatus - 	active | recurrence | relapse | inactive | remission | resolved | unknown
              //severity - mild | moderate | severe
              //code -
              //onsetDateTime -
              <SingleCodeField>{
                generalProperties: <generalFieldsData>{
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldApiName: 'clinicalStatus',
                  fieldName: "Clinical Status",
                  fieldType: 'CodeableConceptField',
                  inputType: 'text',
                  isArray: false,
                  isGroup: false,

                },
                data: g.clinicalStatus
              },
              <SingleCodeField>{
                generalProperties: <generalFieldsData>{
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldApiName: 'verificationStatus',
                  fieldName: "Verification Status",
                  fieldType: 'CodeableConceptField',
                  inputType: 'text',
                  // value: 'confirmed',
                  // isHidden: true,
                  isArray: false,
                  isGroup: false,
                },
                data: g.verificationStatus
              },
              //severity
              <SingleCodeField>{
                generalProperties: <generalFieldsData>{
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldApiName: 'severity',
                  fieldName: "Severity",
                  fieldType: 'CodeableConceptField',
                  inputType: 'text',
                  isArray: false,
                  isGroup: false,
                },
                data: g.severity
              },
              //code
              <CodeableConceptFieldFromBackEnd>{
                generalProperties: <generalFieldsData>{
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldApiName: 'code',
                  fieldName: "Diagnosis Code & Name",
                  fieldType: 'CodeableConceptFieldFromBackEnd',
                  inputType: 'text',
                  isArray: false,
                  isGroup: false,
                  allowedOthers: true,

                },
                data: g.code,
              },



              <IndividualField>{
                generalProperties: <generalFieldsData>{
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  fieldApiName: 'onsetDateTime',
                  fieldName: "Onset Date/Time",
                  fieldType: 'IndividualField',
                  inputType: 'datetime-local',
                  isArray: false,
                  isGroup: false,
                },
                data: ""
              }
            ]
          }
        });

        dRef.afterClosed().subscribe((e) => {
          let result = e.values;
// $#$          // /* alert(JSON.stringify(result) */);
          const requiredValues = ['code'];
          if (Object.keys(result || {}).length == 0 ||
            requiredValues.some(rv => !result.hasOwnProperty(rv) || !result[rv] || (Array.isArray(result[rv]) && result[rv].length == 0))
          ) {
            this.errorService.openandCloseError("Diagnosis Code & Name is required to add a diagnosis. Diagnosis was not added.");
            return;
          }
          // turn result.code into codeable concept if it's a string
          const turnToCodeableConcept = (code: any) => {
// $#$            // /* alert(JSON.stringify(result[code]) */);
            if (result && result[code] && typeof result[code] === 'string') {
              // spilt`
              const codeParts = result[code].split('$#$');
              if (codeParts.length >= 3) {
                result[code] = {
                  coding: [
                    {
                      system: codeParts[2],
                      code: codeParts[0],
                      display: codeParts[1]
                    }
                  ],
                  text: codeParts[1]
                };
              } else {
                result[code] = {

                  text: result[code]
                };
              }
            } else {
              //dis, code and system are present
              if (result && result[code] && result[code].display && result[code].code
                && result[code].system
              ) {
                result[code] = {
                  coding: [
                    {
                      system: result[code].system,
                      code: result[code].code,
                      display: result[code].display
                    }
                  ],
                  text: result[code].display
                };
              }

            }
          }
          // Build Condition resources from symptoms form with clone rule
          result['verificationStatus'] = result['verificationStatus'] ?? "confirmed";
          turnToCodeableConcept('verificationStatus');
          turnToCodeableConcept('severity');
          turnToCodeableConcept('code');
          turnToCodeableConcept('clinicalStatus');
          const encounterId = this.state.currentEncounter.getValue()?.id;
          if (!encounterId) {
            this.errorService.openandCloseError('Encounter ID is missing. Please re-initiate the encounter.');
            return;
          }

          const conditions = this.buildConditionResources([result], patientId, encounterId, performerRef);
          if (!conditions.length) {
            this.errorService.openandCloseError('Diagnosis could not be created from the submitted values.');
            return;
          }

          forkJoin(
            conditions.map((condition) =>
              this.http.post<any>(`${this.backendEndPoint}/Condition`, condition)
            )
          ).subscribe({
            next: (savedConditions) => {
              savedConditions.forEach((saved) => this.stateService.persistLocalResource(saved, 'saved'));
              this.sn.openFromComponent(SuccessMessageComponent, {
                data: { message: 'Diagnosis saved successfully!' },
                duration: 3000,
              });
            },
            error: (err) => {
              console.error('Failed to post diagnosis:', err);
              this.errorService.openandCloseError('Failed to post diagnosis');
            }
          });
        });
      },
      error: (err: any) => {
        console.error('Error fetching diagnosis data:', err);
        this.errorService.openandCloseError('Error fetching diagnosis data. Please try again later.');








      }
    })
  }

  formFieldsDataService = inject(FormFieldsSelectDataService);
  errorService = inject(ErrorService)
  addMedicationRequest(patientId: string, isEditMode: boolean = false, medicationRequestToEdit: MedicationRequest | null = null) {
    if (!patientId && !this.stateService.currentPatientId$.getValue()) {
      this.errorService.openandCloseError("Please access this feature from within a patient's wrapper/dashboard to establish patient context.");
      return;
    }

    // return early if there is no encounter and patient
    if (this.stateService.isEncounterActive() === false) {
      this.errorService.openandCloseError("You need to initiate an encounter before a medication request can be added for this patient");
      return;
    }

    const currentEncounter = this.stateService.currentEncounter.getValue();
    if (currentEncounter?.status !== 'in-progress') {
      this.errorService.openandCloseError("The encounter must be in-progress to add a medication request.");
      return;
    }

    const action = isEditMode ? 'update' : 'request';
    if (!this.authService.can('medicationRequest', action)) {
      this.errorService.openandCloseError(`You do not have permission to ${action} medication requests.`);
      return;
    }
    // NO PATIENT?
    // if(!this.stateService.currentPatientId$.getValue()){
    //     this.errorService.openandCloseError("You need to");
    //   return;
    // }


    // if(!this.stateService.currentEncounter.getValue()?.['patientId']){
    // validate check - check if it editable by its status
    if (isEditMode && medicationRequestToEdit) {
      if (medicationRequestToEdit.status && !['draft'].includes(medicationRequestToEdit.status)) {
        this.errorService.openandCloseError(`This Medication Request cannot be edited as its status is '${medicationRequestToEdit.status}'. Only Medication Requests with status 'draft' can be edited.`);
        return;
      }
    }


    const dRef = this.dialog.open(AddMedicineRequestsComponent, {
      maxHeight: '90vh',
      maxWidth: '650px',
      autoFocus: false,
      data: {
        isEditMode: isEditMode,
        medicationRequest: medicationRequestToEdit
      }
    })

    dRef.afterClosed().subscribe((result) => {

      //         {
      //     "values": [
      //         {
      //             "status": "active",
      //             "intent": "order",
      //             "priority": "routine",
      //             "medicationCodeableConcept": "tugu$#$tugu$#$https://elikita-server.daalitech.com",
      //             "performerType": {
      //                 "code": "registerednurse",
      //                 "display": "Registered Nurse",
      //                 "system": "http://hl7.org/fhir/CodeSystem/medication-intended-performer-role"
      //             },
      //             "reasonCode": "103009000$#$Headache due to cold exposure$#$http://snomed.info/sct",
      //             "reasonReference": [
      //                 {
      //                     "reference": "6c2a264c-a952-401f-b5f8-528f9f435640",
      //                     "display": "sdjjfjf"
      //                 }
      //             ],
      //             "dosageInstruction": ""
      //         }
      //     ]
      // }
      console.log('Medication Request dialog closed with result:', result);
      // Handle the result here (e.g., save to backend or update state)
      // if no values, return
      if (!result || !result.values || (result.values.length && result.values.length === 0)) {
        this.errorService.openandCloseError('No Medication Request was created as the form was closed without submission.');
        return;
      }
      const groupIdentifier = ((): any => {
        // Editing should not move a request to a new group.
        // Preserve the existing groupIdentifier if present; otherwise generate one.
        const existing = isEditMode ? (medicationRequestToEdit as any)?.groupIdentifier : null;
        if (existing?.value) return existing;
        return this.utilityService.generateRequisition({
          prefix: 'REQ',
          resourceType: 'medReq',
          system: "https://elikita-server.daalitech.com"
        });
      })();

      let values = result.values;

      const isReturnedValueAnArray = Array.isArray(values);
      if (isReturnedValueAnArray) {
        console.log('The returned value is an array.');
      } else {
        console.log('The returned value is not an array.');
      }

      if (!isReturnedValueAnArray) {
        values = [values];
      }
      let medicationRequestBundle: any = [];
      console.log('Medication Request Values:', values)
      console.log(this.authService.user.getValue())
      medicationRequestBundle = values.map((val: any) => {
        // if (val.reasonCode && !Array.isArray(val.reasonCode)) {
        //   val.reasonCode = [val.reasonCode];
        // }
        // if (val.reasonReference && !Array.isArray(val.reasonReference)) {
        //   val.reasonReference = [val.reasonReference];
        // }
        return {
          // ...this.fhirTransformService.transformValues('MedicationRequest', val),
          ...val,
          // subject: {
          //   reference: `Patient/${this.stateService.currentEncounter.getValue()?.['patientId']}`
          // },
          encounter: {
            reference: `Encounter/${this.stateService.currentEncounter.getValue()?.['id']}`
          },
          groupIdentifier: groupIdentifier,
          resourceType: 'MedicationRequest',
          authoredOn: new Date().toISOString(),
          requester: {
            reference: `Practitioner/${this.authService.user.getValue()?.['fhirResourceId']}`
          },
          recorder: {
            reference: `Practitioner/${this.authService.user.getValue()?.['fhirResourceId']}`
          },

        }
      }
      );
      console.log('Transformed Medication Request Bundle:', medicationRequestBundle);
      //process the medicationRequestBundle to a real fhir bundle and post to backend
      let fhirBundle: Bundle<any>;
      if (!isEditMode) {
        fhirBundle = {
          resourceType: "Bundle",
          type: "transaction",
          entry: medicationRequestBundle.map((resource: any) => ({
            resource,
            request: {
              method: "POST",
              url: 'MedicationRequest'
            }
          }))
        } as Bundle<any>;
      } else {
        fhirBundle = {
          resourceType: "Bundle",
          type: "transaction",
          entry: [
            {
              resource: {
                ...medicationRequestBundle[0],
                id: medicationRequestToEdit?.id
              },
              request: {
                method: "PUT",
                url: `MedicationRequest/${medicationRequestToEdit?.id}`
              }
            }
          ]

        }
      }
      //debugging backend post
      // this.http.post(` http://localhost:5056/api/debug/log`, fhirBundle).subscribe();
      this.fhirResourceService.postBundle(fhirBundle)
        // .pipe(switchMap((e: any) => {
        //   return this.chargeItemBuilder.prepareChargeItemsFromMedicationRequests(
        //     e.bundle.entry?.map((e: any) => e.resource as MedicationRequest)
        //   )

        // }))
        .subscribe({
          next: (res: any) => {
            console.log('Medication Request Bundle posted successfully:', res);

            // Ã¢Å“â€¦ Trigger notifications for each medication request
            const responseBundle = res?.bundle || res;
            const successfullMedRequestIndexes = [] as number[];
            if (responseBundle?.entry && Array.isArray(responseBundle.entry)) {

              responseBundle.entry.forEach((entry: any, index: number) => {

                if (entry.resource && entry.resource.resourceType === 'MedicationRequest') {
                  successfullMedRequestIndexes.push(index);
                  const persistedMedicationRequest = entry.resource;
                  const originalRequestData = medicationRequestBundle[index] || {};

                  // Ensure ID is present
                  if (!persistedMedicationRequest.id && entry.response?.location) {
                    const match = entry.response.location.match(/MedicationRequest\/([^\/\?#_]+)/);
                    if (match) {
                      persistedMedicationRequest.id = match[1];
                    }
                  }

                  if (persistedMedicationRequest.id) {
                    this.triggerMedicationRequestNotification(
                      persistedMedicationRequest,
                      originalRequestData
                    );
                  } else {
                    console.warn('Ã¢Å¡Â Ã¯Â¸Â MedicationRequest has no ID, skipping notification');
                  }
                }
              });
              // rigger the other medreq notif. for all successful med
              const successfulMedicationRequests = successfullMedRequestIndexes.map((index: number) => {
                return responseBundle.entry[index].resource;
              });
              this.triggerMedicationRequestNotifications(successfulMedicationRequests)

            }

            // Show success message
            this.sn.openFromComponent(SuccessMessageComponent, {
              data: {
                message: `Medication Request(s) created successfully.`
              },
              duration: 3000,
            })
            // Notify UI lists to refresh (full refresh for creates)
            try {
              this.resourceRefresh.notify('medicine-requests', { full: true });
            } catch (e) {
              // non-blocking
            }
          },
          error: (err: any) => {
            console.error('Error posting Medication Request Bundle:', err);

            // Ã¢Å“â€¦ Log the exact server error
            if (err.error?.issue && Array.isArray(err.error.issue)) {
              console.error('Ã¢ÂÅ’ Server validation errors:');
              err.error.issue.forEach((issue: any, index: number) => {
                console.error(`  Issue ${index + 1}:`);
                console.error(`    - Severity: ${issue.severity}`);
                console.error(`    - Code: ${issue.code}`);
                console.error(`    - Details: ${issue.details?.text || 'N/A'}`);
                console.error(`    - Expression: ${issue.expression?.join(', ') || 'N/A'}`);
              });
            }

            // Also log the full payload for debugging
            console.log('Ã°Å¸â€œâ€¹ Full error response:', JSON.stringify(err.error, null, 2));

            this.errorService.openandCloseError(`Error creating Medication Request(s). Please try again later.`);
          }
        })

    });



    // In any component



    // } else {
    //   this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
    // }


  }
  private triggerMedicationRequestNotifications(medicationRequests: MedicationRequest[]): void {
    const organizationId = this.authService.user.getValue()?.organizationId ?? null;

    if (!organizationId) {
      console.warn('No organization ID found, skipping notifications');
      return;
    }

    const patientId = this.stateService.currentPatientId$.getValue();

    // Get patient name for notification message
    this.utilityService.getPatientName(patientId).pipe(
      take(1)
    ).subscribe({
      next: (patientName) => {
        medicationRequests.forEach((mr) => {
          if (!mr.id) {
            console.warn('MedicationRequest has no ID, skipping notification');
            return;
          }

          // Extract medication display name
          const medicationDisplay =
            mr.medicationReference?.display ||
            mr.medicationCodeableConcept?.text ||
            mr.medicationCodeableConcept?.coding?.[0]?.display ||
            'Unknown medication';

          // Determine urgency based on priority
          const urgency = mr.priority === 'stat' || mr.priority === 'urgent' ? 'high' : 'normal';

          // this.notificationService.triggerNotification({
          //   resourceType: 'MedicationRequest',
          //   resourceId: mr.id,
          //   organizationId: organizationId,
          //   targetRoles: ['pharmacist', 'pharmacy'], // Notify pharmacy staff
          //   title: 'New Prescription Available',
          //   message: `${patientName || 'Patient'} has a new prescription for ${medicationDisplay}`,
          //   sendEmail: urgency === 'high', // Send email for urgent prescriptions
          //   data: {
          //     patientId: patientId || '',
          //     medicationDisplay: medicationDisplay,
          //     urgency: urgency,
          //     priority: mr.priority || 'routine',
          //     intent: mr.intent
          //   }
          // }).subscribe({
          //   next: () => console.log(`Ã¢Å“â€¦ Notification sent for MedicationRequest ${mr.id}`),
          //   error: (err) => console.error(`Ã¢ÂÅ’ Failed to send notification for MedicationRequest ${mr.id}`, err)
          // });

          // Ã¢Å“â€¦ Post to Firebase Realtime Database
          // 1. Notify Pharmacy
          this.firebaseAlertService.postRoleAlert(organizationId, 'pharmacy', {
            title: 'New Prescription Available',
            description: `${patientName || 'Patient'} has a new prescription for ${medicationDisplay}`,
            url: `/app/medicine-requests`,
            query: { medRequestId: mr.id, patientId: patientId }
          }).subscribe();

          // 2. Notify Nurse if they are mentioned as performer
          const performerDisplay = mr.performer?.display?.toLowerCase() || '';
          const performerType = (mr as any).performerType?.text?.toLowerCase() || '';

          if (performerDisplay.includes('healthcareassistant') || performerType.includes('healthcareassistant')) {
            this.firebaseAlertService.postRoleAlert(organizationId, 'healthcareassistant', {
              title: 'Medication Administration Task',
              description: `Nurse task: Administer ${medicationDisplay} to ${patientName || 'Patient'}`,
              url: `/app/medicine-requests`,
              query: { medRequestId: mr.id, patientId: patientId }
            }).subscribe();
          }

        });
      },
      error: (err) => {
        console.error('Failed to get patient name for notification', err);
        // Still send notifications without patient name
        this.sendNotificationsWithoutPatientName(medicationRequests, organizationId, patientId);
      }
    });
  }
  /**
   * Fallback method to send notifications without patient name
   */
  private sendNotificationsWithoutPatientName(
    medicationRequests: MedicationRequest[],
    organizationId: string,
    patientId: string | null
  ): void {
    medicationRequests.forEach((mr) => {
      if (!mr.id) return;

      const medicationDisplay =
        mr.medicationReference?.display ||
        mr.medicationCodeableConcept?.text ||
        mr.medicationCodeableConcept?.coding?.[0]?.display ||
        'Unknown medication';

      const urgency = mr.priority === 'stat' || mr.priority === 'urgent' ? 'high' : 'normal';

      this.notificationService.triggerNotification({
        resourceType: 'MedicationRequest',
        resourceId: mr.id,
        organizationId: organizationId,
        targetRoles: ['pharmacist', 'pharmacy'],
        title: 'New Prescription Available',
        message: `New prescription for ${medicationDisplay}`,
        sendEmail: urgency === 'high',
        data: {
          patientId: patientId || '',
          medicationDisplay: medicationDisplay,
          urgency: urgency,
          priority: mr.priority || 'routine',
          intent: mr.intent
        }
      }).subscribe({
        next: () => console.log(`Ã¢Å“â€¦ Notification sent for MedicationRequest ${mr.id}`),
        error: (err) => console.error(`Ã¢ÂÅ’ Failed to send notification for MedicationRequest ${mr.id}`, err)
      });
    });
  }
  /**
   * Trigger notification to appropriate staff for a Medication Request
   */
  private triggerMedicationRequestNotification(medicationRequest: MedicationRequest, requestData: any): void {
console.log('Triggering notification for MedicationRequest:', medicationRequest);
    // Always notify pharmacy/pharmacist for medication requests
    const targetRoles = ['pharmacist', 'pharmacy', 'pharmacystaff'];
    const title = 'New Medication Request';

    // Get medication display name
    let medicationDisplay = 'Medication';

    // Handle different medication reference formats
    if (medicationRequest.medicationReference?.display) {
      medicationDisplay = medicationRequest.medicationReference.display;
    } else if (medicationRequest.medicationCodeableConcept?.text) {
      medicationDisplay = medicationRequest.medicationCodeableConcept.text;
    } else if (medicationRequest.medicationCodeableConcept?.coding?.[0]?.display) {
      medicationDisplay = medicationRequest.medicationCodeableConcept.coding[0].display;
    } else if (typeof requestData?.medicationCodeableConcept === 'string') {
      // Handle encoded format: "code$#$display$#$system"
      const parts = requestData.medicationCodeableConcept.split('$#$');
      medicationDisplay = parts[1] || parts[0] || 'Medication';
    }

    // Get organization ID
    const organizationId = this.authService.getOrganizationId();

    if (!organizationId) {
      console.warn('Ã¢ÂÅ’ [MED NOTIFICATION] No organization ID found, skipping notification');
      return;
    }

    // Get patient and requester info
    const patientId = medicationRequest.subject?.reference?.split('/')[1] ||
      this.stateService.currentEncounter.getValue()?.['patientId'] || '';
    const currentUser = this.authService.getCurrentUser();
    const requesterName = currentUser?.name || currentUser?.display || 'Unknown';

    // Get dosage info if available
    const dosage = medicationRequest.dosageInstruction?.[0];
    const dosageText = dosage ? `${dosage.text || dosage.timing?.repeat?.frequency || 'As directed'}` : 'As prescribed';

    const notificationPayload = {
      resourceType: 'MedicationRequest',
      resourceId: medicationRequest.id || '',
      organizationId: organizationId,
      targetRoles: targetRoles,
      title: title,
      message: `${requesterName} prescribed: ${medicationDisplay}`,
      sendEmail: false,
      data: {
        patientId: patientId,
        medication: medicationDisplay,
        dosage: dosageText,
        intent: medicationRequest.intent || 'order',
        status: medicationRequest.status || 'active',
        requesterName: requesterName,
        requesterId: currentUser?.id || ''
      }
    };

    this.notificationService.triggerNotification(notificationPayload).subscribe({
      next: () => {
        console.log(`Ã¢Å“â€¦ [MED NOTIFICATION] Notification sent to: ${targetRoles.join(', ')} for ${medicationDisplay}`);
      },
      error: (err) => {
        console.error('Ã¢ÂÅ’ [MED NOTIFICATION] Failed to send notification');
        console.error('Ã¢ÂÅ’ [MED NOTIFICATION] Error details:', err);
      }
    });

    // Ã¢Å“â€¦ Trigger messaging thread
    this.triggerMedicationRequestMessagingThread(
      medicationRequest,
      requestData,
      title,
      medicationDisplay,
      organizationId
    );
  }

  medication_status = [
    "active", "on-hold", "ended", "stopped", "completed", "cancelled", "entered-in-error"


  ]
  observation_status = [
    "registered",
    "preliminary",
    "final",
    "amended",
    "corrected",
    "cancelled",
    "entered-in-error",
    "unknown"
  ]

  observation_units = [
    "kg",     // kilograms
    "g",      // grams
    "mg",     // milligrams
    "ug",     // micrograms
    "L",      // liters
    "mL",     // milliliters
    "cm",     // centimeters
    "mm",     // millimeters
    "m",      // meters
    "mmHg",   // millimeters of mercury (blood pressure)
    "bpm",    // beats per minute (heart rate)
    "/min",   // per minute (respiration rate)
    "Ã‚Â°C",     // degrees Celsius (body temperature)
    "%",      // percent (e.g., oxygen saturation)
    "mol/L",  // moles per liter (common for electrolytes)
    "mmol/L", // millimoles per liter (common for glucose, cholesterol)
    "mg/dL",  // milligrams per deciliter
    "ng/mL",  // nanograms per milliliter
    "U/L",    // units per liter (e.g., liver enzymes)
    "IU/L",   // international units per liter
    "mEq/L",  // milliequivalents per liter
    "cm[H2O]",// centimeters of water (respiratory pressure)
    "s",      // seconds
    "min",    // minutes
    "h",      // hours
    "d"       // days
  ]



  // addTask(patientId: string) {
  //   this.dialog.open(TestingTasksComponent, {
  //     maxHeight: '90vh',
  //     maxWidth: '650px',
  //     backdropClass: 'custom-backdrop',
  //     panelClass: 'custom-dialog-panel',
  //     autoFocus: false,
  //     data: {
  //       patientId
  //     }
  //   });
  // }
  utilityService = inject(UtilityService);

  /**
   * Build billing resources (ChargeItem + Invoice) for a prepared-for-submission ServiceRequest.
   *
   * - Skips billing (returns null) when no ChargeItemDefinition exists for the ServiceRequest code.
   * - Uses ChargeItem.code.coding[0].code = `${categoryCode}-${actualCode}` (category from UtilityService ValueSet mapping).
   * - Does NOT rely on ChargeItem.productReference nor ChargeItem.service for identification.
   */
  prepareChargeItemAndInvoiceForServiceRequest(
    serviceRequest: ServiceRequest,
    serviceRequestFullUrl?: string
  ): Observable<
    | {
      chargeItemEntry: {
        fullUrl: string;
        resource: ChargeItem;
        request: { method: string; url: string };
      };
      invoiceEntry: {
        fullUrl: string;
        resource: any;
        request: { method: string; url: string };
      };
      serviceEntries?: Array<{
        fullUrl: string;
        resource: Observation | DiagnosticReport | ImagingStudy | Procedure | any;
        request: { method: string; url: string };
      }>;
    }
    | null
  > {
    // Be defensive: some callers might pass a non-FHIR shape.
    const srCode: any = (serviceRequest as any)?.code;
    const normalizedCodeableConcept = Array.isArray(srCode) ? srCode[0] : srCode;
    const actualCode =
      normalizedCodeableConcept?.coding?.[0]?.code ||
      (typeof normalizedCodeableConcept?.text === 'string' ? normalizedCodeableConcept.text : '') ||
      (typeof srCode === 'string' ? srCode.split('$#$')[0] : '') ||
      '';

    if (!actualCode) return of(null);

    const localDefs = (this.stateService?.orgWideResources?.chargeItemDefinitions?.getValue?.() || [])
      .map((x: any) => x?.actualResource as ChargeItemDefinition)
      .filter(Boolean);

    const matchesActiveDefinition = (def: ChargeItemDefinition | null | undefined) => {
      if (!def || def.status !== 'active') return false;
      const codingMatch = (def?.code?.coding || []).some((c: any) => c?.code === actualCode);
      const textMatch = (def?.code?.text || '').trim() === actualCode;
      return codingMatch || textMatch;
    };

    const matchedLocalDef = localDefs.find(matchesActiveDefinition) || null;

    const fetchDefsFromServer$ = this.utilityService
      .threeTierQueryAndSyncToStateOnce$<ChargeItemDefinition>({
        resourceType: 'ChargeItemDefinition',
        scope: 'orgWide',
        urlSearchObject: { status: 'active' },
        querySearchObject: [{ key: 'status', value: 'active' },
        { key: 'code.coding.code', value: actualCode }
        ],
        tier1FollowNextLinks: true,
        tier1MaxPages: 100,
        expectedMinLength: 1,
        tier3FollowNextLinks: true,
        tier3MaxPages: 100,
        count: 199
      })
      .pipe(
        map((defs: ChargeItemDefinition[]) => (defs || []).filter(Boolean)),
        catchError(() => of([] as ChargeItemDefinition[]))
      );

    const defs$ = matchedLocalDef ? of([matchedLocalDef]) : fetchDefsFromServer$;

    return defs$.pipe(
      map((defs: ChargeItemDefinition[]) => {
        const def = defs.find(matchesActiveDefinition) || null;
// $#$        // /* alert("found bill" + JSON.stringify(def) */)
        // Respect the rule: no definition => no billing // Nt again, we nw just nt add prices
        if (!def?.id) return null;
        return def;
      }),
      switchMap((def) => {
        if (!def) return of(null);

        const nowIso = new Date().toISOString();
        const subjectRef = (serviceRequest as any)?.subject;
        const encounterRef = (serviceRequest as any)?.encounter;

        const makeUrnUuid = () => {
          try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anyCrypto: any = (globalThis as any)?.crypto;
            const id = anyCrypto?.randomUUID?.();
            return `urn:uuid:${id || Math.random().toString(16).slice(2)}`;
          } catch {
            return `urn:uuid:${Math.random().toString(16).slice(2)}`;
          }
        };

        const chargeItemFullUrl = makeUrnUuid();
        const invoiceFullUrl = makeUrnUuid();

        const priceComponents = (def as any)?.propertyGroup?.[0]?.priceComponent ?? [];
        const asNumber = (v: any) => (v === undefined || v === null || v === '' ? 0 : Number(v));

        const currency =
          (def as any)?.propertyGroup?.[0]?.priceComponent?.find((pc: any) => pc?.amount?.currency)?.amount?.currency ||
          (def as any)?.propertyGroup?.[0]?.priceComponent?.[0]?.amount?.currency ||
          'NGN';

        const money = (value: number) => ({
          value,
          currency
        });

        const componentTotals: Record<string, number> = {
          base: 0,
          surcharge: 0,
          tax: 0,
          deduction: 0,
          discount: 0,
          informational: 0
        };

        (Array.isArray(priceComponents) ? priceComponents : []).forEach((pc: any) => {
          const t = (pc?.type ?? '').toString();
          const amt = asNumber(pc?.amount?.value);
          if (!t) return;
          if (componentTotals[t] === undefined) componentTotals[t] = 0;
          componentTotals[t] += amt;
        });

        const totalNetValue =
          (componentTotals['base'] || 0) +
          (componentTotals['surcharge'] || 0) -
          (componentTotals['deduction'] || 0) -
          (componentTotals['discount'] || 0);

        const totalGrossValue = totalNetValue + (componentTotals['tax'] || 0);

        const totalPriceComponent = (['base', 'surcharge', 'tax', 'deduction', 'discount', 'informational'] as const)
          .map((t) => {
            const v = componentTotals[t] || 0;
            if (!Number.isFinite(v) || v === 0) return null;
            return {
              type: t,
              amount: money(v)
            };
          })
          .filter(Boolean);

        const lineItemPriceComponent = (Array.isArray(priceComponents) ? priceComponents : [])
          .map((pc: any) => {
            const value = asNumber(pc?.amount?.value);
            if (!Number.isFinite(value) || value === 0) return null;
            return {
              type: pc?.type,
              code: pc?.code,
              factor: pc?.factor,
              amount: money(value)
            };
          })
          .filter(Boolean);

        return this.utilityService.getServiceRequestCategoryForCode(actualCode).pipe(
          switchMap((categoryMeta) => {
            const categoryCode = (categoryMeta?.categoryCode || 'General').trim() || 'General';
            const combinedCode = `${categoryCode}-${actualCode}`;

            const display =
              serviceRequest?.code?.coding?.[0]?.display ||
              serviceRequest?.code?.text ||
              def?.code?.coding?.[0]?.display ||
              def?.code?.text ||
              actualCode;

            const srRefForBasedOn = (() => {
              const srId = (serviceRequest as any)?.id;
              if (srId) return { reference: `ServiceRequest/${srId}` };
              if (serviceRequestFullUrl) return { reference: serviceRequestFullUrl };
              return undefined;
            })();

            const serviceCategory = (categoryCode || '').toString().trim().toLowerCase();
            const isLaboratory = /lab|laboratory/.test(serviceCategory);
            const isImaging = /imaging|radiology|xray|scan|ultra|ct|mri/.test(serviceCategory);
            const isSurgery = /surgery|surgical/.test(serviceCategory);
            const isProcedure = /procedure/.test(serviceCategory) || isSurgery;

            let obsCodes$: Observable<any[]> = of([]);
            if (isLaboratory) {
              obsCodes$ = this.getConfiguredRequiredObservationCodes$(actualCode);
            }

            return obsCodes$.pipe(
              map((configuredCodes) => {
                const serviceEntries: Array<{
                  fullUrl: string;
                  resource: any;
                  request: { method: string; url: string };
                }> = [];

                const pushEntry = (resourceType: string, resource: any) => {
                  const fullUrl = makeUrnUuid();
                  serviceEntries.push({
                    fullUrl,
                    resource: { resourceType, ...resource },
                    request: { method: 'POST', url: resourceType }
                  });
                  return fullUrl;
                };

                const chargeItemServiceRefs: Array<{ reference: string; display?: string }> = [];

                if (isLaboratory) {
                  const codesToUse = (configuredCodes?.length ? configuredCodes : [(serviceRequest as any)?.code]).filter(Boolean);

                  const obsFullUrls: string[] = [];
              // for (const cc of codesToUse) {
              const obsFullUrl = pushEntry('Observation', {
                status: 'registered',
                code: codesToUse[0],
                category: [{ text: categoryMeta?.categoryDisplay || 'Laboratory' }],
                ...(subjectRef?.reference ? { subject: subjectRef } : {}),
                ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
                ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {})
                // No value/effective yet; this is a placeholder before payment and measurement.
              } satisfies Partial<Observation>);
              obsFullUrls.push(obsFullUrl);

              const codeLabel = (codesToUse[0] as any)?.coding?.[0]?.code || (codesToUse[0] as any)?.text || 'Observation';
              chargeItemServiceRefs.push({ reference: obsFullUrl, display: `${display} (${codeLabel})` });
              // }

              // const drFullUrl = pushEntry('DiagnosticReport', {
              //   status: 'registered',
              //   code: (serviceRequest as any)?.code,
              //   ...(subjectRef?.reference ? { subject: subjectRef } : {}),
              //   ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
              //   ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {}),
              //   ...(obsFullUrls.length ? { result: obsFullUrls.map((u) => ({ reference: u })) } : {})
              // } satisfies Partial<DiagnosticReport>);

              // chargeItemServiceRefs.push({ reference: drFullUrl, display: `${display} (DiagnosticReport)` });
            } else if (isImaging) {
              const imagingFullUrl = pushEntry('ImagingStudy', {
                status: 'registered',
                ...(subjectRef?.reference ? { subject: subjectRef } : {}),
                ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
                ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {})
              } satisfies Partial<ImagingStudy>);

              // const drFullUrl = pushEntry('DiagnosticReport', {
              //   status: 'registered',
              //   code: (serviceRequest as any)?.code,
              //   ...(subjectRef?.reference ? { subject: subjectRef } : {}),
              //   ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
              //   ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {}),
              //   imagingStudy: [{ reference: imagingFullUrl }]
              // } satisfies Partial<DiagnosticReport>);

              chargeItemServiceRefs.push({ reference: imagingFullUrl, display: `${display} (ImagingStudy)` });
              // chargeItemServiceRefs.push({ reference: drFullUrl, display: `${display} (DiagnosticReport)` });
            } else if (isProcedure || isSurgery) {
              const procFullUrl = pushEntry('Procedure', {
                status: 'preparation',
                code: (serviceRequest as any)?.code,
                ...(subjectRef?.reference ? { subject: subjectRef } : {}),
                ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
                ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {})
              } satisfies Partial<Procedure>);

              chargeItemServiceRefs.push({ reference: procFullUrl, display: `${display} (${isSurgery ? 'Surgery' : 'Procedure'})` });
            } else {
              const obsFullUrl = pushEntry('Observation', {
                status: 'registered',
                code: (serviceRequest as any)?.code,
                category: [{ text: categoryMeta?.categoryDisplay || 'Laboratory' }],
                ...(subjectRef?.reference ? { subject: subjectRef } : {}),
                ...(encounterRef?.reference ? { encounter: encounterRef } : {}),
                ...(srRefForBasedOn ? { basedOn: [srRefForBasedOn] } : {})
                // No value/effective yet; this is a placeholder before payment and measurement.
              } satisfies Partial<Observation>);
              chargeItemServiceRefs.push({ reference: obsFullUrl, display: `${display} (Observation)` });

            }

            const organizationId = this.authService.getOrganizationId();
            const performingOrganization = organizationId ? { reference: `Organization/${organizationId}` } : undefined;

            const chargeItem: ChargeItem = {
              resourceType: 'ChargeItem',
              status: 'billed',
              definitionCanonical: [`${this.backendEndPoint}/ChargeItemDefinition/${def?.id || new Date().getTime()}`],
              identifier: [
                this.utilityService.buildIdentifier({
                  system: `${this.backendEndPoint}/ChargeItem/identifier`,
                  resourceType: 'ChargeItem',
                  typeCoding: {
                    code: combinedCode,
                    system: `${this.backendEndPoint}`,
                    display: display
                  },
                  assigner: {
                    reference: 'E-Likita',
                    display: 'E-Likita Health'
                  }
                })
              ],
              code: {
                coding: [
                  {
                    code: combinedCode,
                    system: `${this.backendEndPoint}`,
                    display
                  }
                ],
                text: display
              },
              context: encounterRef,
              ...(subjectRef?.reference ? { subject: subjectRef } : {}),
              ...(encounterRef?.reference ? { context: encounterRef } : {}),
              quantity: { value: 1 },
              occurrenceDateTime: (serviceRequest as any)?.authoredOn || nowIso,
              ...(chargeItemServiceRefs.length ? { service: chargeItemServiceRefs } : {}),
              ...(performingOrganization ? { performingOrganization } : {})
            } as any;

            const invoice: any = {
              resourceType: 'Invoice',
              status: 'issued',
              subject: subjectRef,
              date: nowIso,
              identifier: [
                this.utilityService.buildIdentifier({
                  system: `${this.backendEndPoint}/Invoice/identifier`,
                  resourceType: 'Invoice',
                  typeCoding: {
                    code: `${combinedCode}-INVOICE`,
                    system: `${this.backendEndPoint}`,
                    display: `${display} Invoice`
                  },
                  assigner: {
                    reference: 'E-Likita',
                    display: 'E-Likita Health'
                  }
                })
              ],
              issuer: {
                reference: `Organization/${this.authService.getOrganizationId()}`,

              },

              lineItem: [
                {
                  sequence: 1,
                  chargeItemReference: { reference: chargeItemFullUrl },
                  ...(lineItemPriceComponent?.length && def ? { priceComponent: lineItemPriceComponent } : {})
                }
              ],

              ...(totalPriceComponent?.length && def ? { totalPriceComponent } : {}),
              ...(Number.isFinite(totalGrossValue) && def ? { totalGross: money(Math.max(0, totalGrossValue)) } : {}),
              // ...(chargeItemServiceRefs.length ? { service: chargeItemServiceRefs } : {}),
              // ...(performingOrganization ? { performingOrganization } : {})
            };

            return {
              chargeItemEntry: {
                fullUrl: chargeItemFullUrl,
                resource: chargeItem,
                request: { method: 'POST', url: 'ChargeItem' } as const
              },
              invoiceEntry: {
                fullUrl: invoiceFullUrl,
                resource: invoice,
                request: { method: 'POST', url: 'Invoice' } as const
              },
              ...(serviceEntries.length ? { serviceEntries } : {})
            };
              })
            );
          })
        );
      })
    );
  }

  resumeConsultation(patientId: string) {
    let currentEncounter: any = null;
    this.stateService.currentEncounter.subscribe(enc => currentEncounter = enc).unsubscribe();
    
    if (!currentEncounter || currentEncounter.status !== 'triaged') {
      this.errorService.openandCloseError('No triaged encounter found to resume.');
      return;
    }

    this.formFieldsDataService.getFormFieldSelectData('encounter', 'participant').subscribe((participantData: any) => {
      const actorsFormFields = [
        {
          generalProperties: {
            fieldApiName: 'participant',
            fieldName: 'Add Participants',
            fieldLabel: 'Participants',
            fieldType: 'IndividualReferenceField',
            isArray: true,
            isGroup: false
          },
          data: participantData,
          dataType: 'ReferenceDataType'
        }
      ];

      const authUser: any = this.authService?.user?.getValue?.();
      const currentUserName = authUser?.['display'] || authUser?.['fullName'] || authUser?.['name'] || authUser?.['email'];
      const currentUserId = authUser?.['fhirResourceId'] || authUser?.['id'] || authUser?.['sub'];
      const currentUserRef = currentUserId ? `Practitioner/${currentUserId}` : undefined;

      const dRef = this.dialog.open(ResumeConsultationDialogComponent, {
        width: '500px',
        data: { actorsFormFields, currentUserName }
      });

      dRef.afterClosed().subscribe(async (result) => {
        if (result) {
          // Merge actors
          if (!currentEncounter.participant) {
            currentEncounter.participant = [];
          }
          
          // ALWAYS add current user automatically
          if (currentUserRef) {
            const currentUserExists = currentEncounter.participant.find((existing: any) => 
              existing.individual?.reference === currentUserRef ||
              existing.actor?.reference === currentUserRef
            );
            if (!currentUserExists) {
              currentEncounter.participant.push({ individual: { reference: currentUserRef, display: currentUserName } });
            }
          }
          
          if (result && result.participant && Array.isArray(result.participant)) {
            result.participant.forEach((p: any) => {
              // Handle both ReferenceFieldArray ({ actor: { reference: '...' } }) and IndividualReferenceField ({ reference: '...' })
              const actor = p.actor ? p.actor : p;
              if (actor && actor.reference) {
                // Check if already exists to avoid duplicates
                const exists = currentEncounter.participant.find((existing: any) => 
                  existing.individual?.reference === actor.reference ||
                  existing.actor?.reference === actor.reference
                );
                
                if (!exists) {
                  currentEncounter.participant.push({ individual: { reference: actor.reference, display: actor.display } });
                }
              }
            });
          }

          // Update status
          currentEncounter.status = 'in-progress';
          
          this.http.put(`${this.backendEndPoint}/Encounter/${currentEncounter.id}`, currentEncounter).subscribe({
            next: (updatedEncounter) => {
              this.stateService.setCurrentEncounter(updatedEncounter as any);
              this.setEncounterState(patientId, 'in-progress');
              this.sn.openFromComponent(SuccessMessageComponent, {
                data: { message: 'Consultation resumed successfully', action: 'Dismiss' },
                duration: 4000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            },
            error: (err) => {
              console.error(err);
              this.errorService.openandCloseError('Failed to resume consultation.');
            }
          });
        }
      });
    });
  }

  addInventory() {
    const InventoryDetailsFormFields = this.utilityService.convertFormFields(new Map([
      ['description', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'description',
              fieldName: "Product / Supply Description",
              fieldType: 'IndividualField',
              inputType: 'textarea',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],
      ['brandName', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'brandName',
              fieldName: "Brand Name",
              fieldType: 'IndividualField',
              inputType: 'text',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],

      ['status', {
        formFields: <FormFields[]>[
          <SingleCodeField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'status',
              fieldName: "Status",
              fieldType: 'SingleCodeField',
              inputType: 'text',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },
            data: 'active | inactive | entered-in-error'.split(' | ')
          },
        ]
      }],

      ['baseUnit', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'baseUnit',
              fieldName: "Base Unit",
              fieldPlaceholder: "e.g. sachet, packet, ml e.t.c.",
              fieldType: 'IndividualField',
              inputType: 'text',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],
      ['netContent', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'netContent',
              fieldName: "Quantity to be Stocked",
              fieldType: 'IndividualField',
              inputType: 'number',
              isArray: false,
              isGroup: false,
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },
          },
        ]
      }],
      ['expiry', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'expiry',
              fieldName: "Expiry Date For Expirable Products",
              fieldType: 'IndividualField',
              inputType: 'datetime-local',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],
    ]));

    this.dialog.open(DynamicFormsV2Component, {
      data: {
        formMetaData: {
          formName: "Supplies Stock Form",
          formDescription: "Use this form to keep track of yoour stock supplies",
          showSubmitButton: true,
          submitText: "Submit"

        } as formMetaData,
        formFields: InventoryDetailsFormFields
      }
    })
  }

  addMedStock() {
    const InventoryDetailsFormFields = this.utilityService.convertFormFields(new Map([

      ['baseUnit', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'baseUnit',
              fieldName: "Base Unit",
              fieldPlaceholder: "e.g. sachet, packet, ml e.t.c.",
              fieldType: 'IndividualField',
              inputType: 'text',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],
      ['netContent', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'netContent',
              fieldName: "Quantity to be Stocked",
              fieldType: 'IndividualField',
              inputType: 'number',
              isArray: false,
              isGroup: false,
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },
          },
        ]
      }],
      ['expiry', {
        formFields: <FormFields[]>[
          <IndividualField>{
            generalProperties: <generalFieldsData>{
              fieldApiName: 'expiry',
              fieldName: "Expiry Date For Expirable Products",
              fieldType: 'IndividualField',
              inputType: 'datetime-local',
              isArray: false,
              isGroup: false,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
            },

          },

        ]
      }],
    ]));

    this.dialog.open(DynamicFormsV2Component, {
      data: {
        formMetaData: {
          formName: "Medicine Supplies Stock Form",
          formDescription: "Use this form to record medicine stock supplies",
          showSubmitButton: true,
          submitText: "Submit"

        } as formMetaData,
        formFields: InventoryDetailsFormFields
      }
    })
  }

  addAnyObservation(patientId: string | null = null) {
    //return earlly if there is no encounter
    if (this.stateService.isEncounterActive() === false) {
      this.errorService.openandCloseError("You need to initiate an encounter before an observation can be added for this patient");
      return null;
    }

    return this.dialog.open(AddObservationComponent, {
      maxHeight: '90vh',
      maxWidth: '900px',
      autoFocus: false,
      data: {
        isAnyCategory: true,

      }
    })
  }

  // Parse "ResourceType/{id}/_history/1" -> { resourceType, id }
  private parseLocation(location: string | undefined): { resourceType: string; id: string } | null {
    if (!location) return null;
    const parts = location.split('/');
    if (parts.length >= 2) {
      return { resourceType: parts[0], id: parts[1] };
    }
    return null;
  }

  // Rewrite all FHIR Reference.reference fields from urn:uuid -> ResourceType/id
  private rewriteReferences(obj: any, urnMap: Map<string, { resourceType: string; id: string }>): void {
    if (!obj || typeof obj !== 'object') return;
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (key === 'reference' && typeof val === 'string' && urnMap.has(val)) {
        const mapped = urnMap.get(val)!;
        obj[key] = `${mapped.resourceType}/${mapped.id}`;
      } else if (Array.isArray(val)) {
        for (const v of val) this.rewriteReferences(v, urnMap);
      } else if (typeof val === 'object') {
        this.rewriteReferences(val, urnMap);
      }
    }
  }

  // Merge server-assigned ids into request bundle and normalize intra-bundle refs
  private materializeTransactionResponse(requestBundle: any, responseBundle: any): any {
    if (!requestBundle || requestBundle.resourceType !== 'Bundle' || !Array.isArray(requestBundle.entry)) return requestBundle;
    if (!responseBundle || responseBundle.resourceType !== 'Bundle' || !Array.isArray(responseBundle.entry)) return requestBundle;

    const reqEntries = requestBundle.entry;
    const resEntries = responseBundle.entry;
    const urnMap = new Map<string, { resourceType: string; id: string }>();

    // Assume response entries align with request order per FHIR spec
    for (let i = 0; i < reqEntries.length; i++) {
      const reqE = reqEntries[i];
      const resE = resEntries[i];

      const locInfo = this.parseLocation(resE?.response?.location);
      if (locInfo && reqE?.fullUrl && reqE?.resource) {
        reqE.resource.id = locInfo.id; // set server id
        urnMap.set(reqE.fullUrl, { resourceType: locInfo.resourceType, id: locInfo.id });
      }

      // If server returned the full resource, prefer it
      if (resE?.resource?.resourceType && resE.resource?.id) {
        reqE.resource = resE.resource;
      }
    }

    // Rewrite all urn:uuid references to ResourceType/id
    for (const reqE of reqEntries) {
      if (reqE?.resource) this.rewriteReferences(reqE.resource, urnMap);
    }

    // Keep bundle shape compatible with your local processor
    return {
      resourceType: 'Bundle',
      type: requestBundle.type || 'transaction',
      entry: reqEntries
    };
  }

  private findResourceInBundle(bundle: any, resourceType: string): any | null {
    const entries = Array.isArray(bundle?.entry) ? bundle.entry : [];
    for (const e of entries) {
      const r = e?.resource ?? e;
      if (r?.resourceType === resourceType) return r;
    }
    return null;
  }

  /**
  * Trigger notification to appropriate staff based on service request type
  */
  notifyServiceRequestCreated(
    serviceRequest: any,
    requestData: any,
    options?: {
      organizationIdOverride?: string;
      routePatientScoped?: boolean;
      additionalExplicitRecipients?: string[];
      legacyTargetRolesOverride?: string[];
      messagingRecipientRolesOverride?: string[];
    }
  ): void {


    // Determine target roles based on category
    const category = serviceRequest.category;
    let targetRoles: string[] = [];
    let title = 'New Service Request';

    // Parse category - handle array, object, or string format
    let categoryCode = '';
    if (Array.isArray(category) && category.length > 0) {

      const firstCat = category[0];
      if (typeof firstCat === 'object') {
        categoryCode = firstCat.text || firstCat.coding?.[0]?.code || firstCat.coding?.[0]?.display || '';
      } else if (typeof firstCat === 'string') {
        categoryCode = firstCat;
      }

    } else if (typeof category === 'string') {

      if (category.includes('$#$')) {
        categoryCode = category.split('$#$')[0];

      } else {
        categoryCode = category;

      }
    } else if (category && typeof category === 'object') {

      categoryCode = category.text || category.coding?.[0]?.code || category.coding?.[0]?.display || '';

    } else {
      console.log('Ã¢Å¡Â Ã¯Â¸Â [NOTIFICATION] Category is null/undefined or unexpected type');
    }

    //console.log('Ã¢Å“â€¦ [NOTIFICATION] Final category code:', categoryCode);

    // Map categories to roles
    const normalizedCategory = categoryCode.toLowerCase().trim();
// $#$    // /* alert("normalizedCategory" + normalizedCategory) */
    switch (normalizedCategory) {
      case 'laboratory':
      case 'lab':
        targetRoles = ['lab', 'labtechnician', 'laboratory', 'alliedhealthprofessional'];
        title = 'New Lab Test Request';

        break;
      case 'radiology':
      case 'imaging':
        targetRoles = ['radiology', 'radiologist', 'imaging', 'alliedhealthprofessional', ];
        title = 'New Imaging Request';
        break;
      case 'pharmacy':
        targetRoles = ['pharmacist', 'pharmacy'];
        title = 'New Pharmacy Request';
        break;
      case 'procedure':
        targetRoles = ['healthcareassistant', 'doctor', 'alliedhealthprofessional', 'primaryhealthcareprovider'];
        title = 'New Procedure Request';
        break;
      case 'consultation':
        targetRoles = ['doctor', 'specialist'];
        title = 'New Consultation Request';
        break;
      case 'referral':
        targetRoles = ['alliedhealthprofessional', 'labtechnician', 'doctor', 'healthcareassistant'];
        title = 'New Referral Request';
        break;
      case 'surgery':
        targetRoles = ['doctor', 'surgeon', 'alliedhealthprofessional', 'primaryhealthcareprovider'];
        title = 'New Surgery Request';
        break;

      default:
        targetRoles = ['healthcareassistant', 'doctor'];
        title = 'New Service Request';
    }

    const legacyTargetRolesSource = options?.legacyTargetRolesOverride ?? [];
    const legacyTargetRolesOverride = legacyTargetRolesSource.filter(Boolean);
    if (legacyTargetRolesOverride.length) {
      targetRoles = legacyTargetRolesOverride;
    }


    // Get code display for message
    let codeDisplay = 'Service';
    const code = requestData.code || serviceRequest.code;



    if (typeof code === 'string') {

      codeDisplay = code;

    } else if (code && typeof code === 'object') {

      codeDisplay = code.text || code.display || code.coding?.[0]?.display || code.coding?.[0]?.code || 'Service';

    } else {
      console.log('Ã¢Å¡Â Ã¯Â¸Â [NOTIFICATION] Code is null/undefined, using default');
    }



    // Ã¢Å“â€¦ Get organization ID from auth service
    const organizationId = options?.organizationIdOverride || this.authService.getOrganizationId();


    if (!organizationId) {
      console.warn('Ã¢ÂÅ’ [NOTIFICATION] No organization ID found, skipping notification');
      return;
    }

    // Get patient ID for additional context.
    const patientId = (serviceRequest?.subject?.reference || '').toString().split('/')[1] || '';

    // Get current user for requester info
    const currentUser = this.authService.getCurrentUser();
    const requesterName = currentUser?.name || currentUser?.display || 'Unknown';


    const notificationPayload = {
      resourceType: 'ServiceRequest',
      resourceId: serviceRequest.id || '',
      organizationId: organizationId,
      targetRoles: targetRoles,
      title: title,
      message: `${requesterName} requested: ${codeDisplay}`,
      sendEmail: false,
      data: {
        priority: requestData.priority || serviceRequest.priority || 'routine',
        patientId: patientId,
        category: categoryCode,
        intent: requestData.intent || serviceRequest.intent || 'order',
        requesterName: requesterName,
        requesterId: currentUser?.id || ''
      }
    };


    this.notificationService.triggerNotification(notificationPayload).subscribe({
      next: (response) => {

        console.log(`Ã¢Å“â€¦ [NOTIFICATION] Notification sent to: ${targetRoles.join(', ')} for ${codeDisplay}`);
      },
      error: (err) => {
        console.error('Ã¢ÂÅ’ [NOTIFICATION] Failed to send notification');
        console.error('Ã¢ÂÅ’ [NOTIFICATION] Error details:', err);
        console.error('Ã¢ÂÅ’ [NOTIFICATION] Error status:', err.status);
        console.error('Ã¢ÂÅ’ [NOTIFICATION] Error message:', err.message);
        console.error('Ã¢ÂÅ’ [NOTIFICATION] Error response:', err.error);
        // Don't show error to user - notification failure shouldn't block the main action
      }
    });

    const serviceRequestType = inferServiceRequestType(serviceRequest);
    const serviceRequestRouteSegment = serviceRequestType === 'laboratory'
      ? 'lab-tests'
      : serviceRequestType;
    const usePatientScopedRoute = options?.routePatientScoped !== false;
    const serviceRequestBaseUrl = patientId && usePatientScopedRoute
      ? `/app/patients/${patientId}/service-requests/${serviceRequestRouteSegment}`
      : `/app/service-requests/${serviceRequestRouteSegment}`;

    // Ã¢Å“â€¦ Post to Firebase Realtime Database
    targetRoles.forEach(role => {
      this.firebaseAlertService.postRoleAlert(organizationId, role, {
        title: title,
        description: `${requesterName} requested: ${codeDisplay}`,
        url: serviceRequestBaseUrl,
        query: { serviceRequestId: serviceRequest.id }
      }).subscribe();
    });

    this.triggerServiceRequestMessagingThread(
      serviceRequest,
      requestData,
      title,
      codeDisplay,
      serviceRequestType,
      organizationId,
      options?.additionalExplicitRecipients ?? [],
      options?.messagingRecipientRolesOverride ?? []
    );

    console.log('Ã°Å¸ÂÂ [NOTIFICATION] Notification trigger completed');
  }

  private triggerServiceRequestMessagingThread(
    serviceRequest: any,
    requestData: any,
    title: string,
    codeDisplay: string,
    serviceRequestType: string,
    organizationId: string,
    additionalExplicitRecipients: string[] = [],
    messagingRecipientRolesOverride: string[] = []
  ): void {
    const sender = this.buildCurrentMessagingParticipant();

    console.groupCollapsed('Ã°Å¸â€œÂ¨ [MESSAGING] triggerServiceRequestMessagingThread');
    console.log('serviceRequest', serviceRequest);
    console.log('requestData', requestData);
    console.log('title/codeDisplay/serviceRequestType', { title, codeDisplay, serviceRequestType });
    console.log('organizationId', organizationId);
    console.log('additionalExplicitRecipients', additionalExplicitRecipients);
    console.log('messagingRecipientRolesOverride', messagingRecipientRolesOverride);
    console.log('resolved sender', sender);

    if (!organizationId || !sender || !serviceRequest?.id) {
      console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] Missing required thread inputs', {
        hasOrganizationId: !!organizationId,
        hasSender: !!sender,
        serviceRequestId: serviceRequest?.id
      });
      console.groupEnd();
      return;
    }

    const subject = this.buildServiceRequestMessagingSubject(serviceRequest);
    const context = {
      contextType: 'service-request',
      contextId: serviceRequest.id,
      serviceRequestId: serviceRequest.id,
      metadata: {
        priority: requestData?.priority || serviceRequest?.priority || 'routine',
        category: this.extractServiceRequestCategoryLabel(requestData?.category ?? serviceRequest?.category),
        serviceRequestType
      }
    };
    const preview = `${sender.display ?? 'Unknown'} requested: ${codeDisplay}`;
    const senderResourceType = sender.resourceType ?? 'Practitioner';
    const senderExplicitRecipients = this.extractMessagingParticipantsFromReferences(
      [
        ...(Array.isArray(serviceRequest?.performer) ? serviceRequest.performer : []),
        ...additionalExplicitRecipients
      ],
      sender.participantId
    );

    console.log('resolved subject', subject);
    console.log('resolved context', context);
    console.log('sender explicit recipients', senderExplicitRecipients);

    const recipients$ = this.resolveMessagingParticipantsForRoles(
      messagingRecipientRolesOverride.length ? messagingRecipientRolesOverride : this.getServiceRequestMessagingRecipientRoles(serviceRequestType),
      organizationId,
      sender.participantId
    ).pipe(
      map((organizationRecipients) => {
        console.log('organization recipients from role resolution', organizationRecipients);
        const mergedParticipants = this.mergeMessagingParticipants(senderExplicitRecipients, organizationRecipients);
        console.log('merged messaging recipients', mergedParticipants);
        return mergedParticipants;
      })
    );

    recipients$.pipe(
      switchMap((participants) => {
        console.log('participants entering ensureThread', participants);
        if (!participants.length) {
          console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] No practitioner recipients resolved for service request messaging thread');
          return of(null);
        }

        return this.messagingThreadsService.ensureThread({
          organizationId,
          threadType: 'service-request',
          sender,
          participants,
          context,
          subject,
          title: `${title}: ${codeDisplay}`
        }).pipe(
          tap((response) => {
            console.log('ensureThread response', response);
          }),
          catchError((error) => {
            console.error('Ã¢ÂÅ’ [MESSAGING] Failed to ensure service request messaging thread', error);
            return of(null);
          })
        );
      }),
      switchMap((response) => {
        const threadId = response?.thread?.threadId;
        console.log('thread response entering communication/notify stage', response);
        if (!threadId) {
          console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] No threadId returned from ensureThread');
          return of(null);
        }

        const participants = Array.isArray(response.thread?.participants)
          ? response.thread.participants
          : [];
        const communicationSentAt = new Date().toISOString();

        return this.createSystemServiceRequestCommunication(
          serviceRequest,
          participants,
          preview,
          communicationSentAt,
          organizationId
        ).pipe(
          tap((communication) => {
            console.log('created system communication', communication);
          }),
          switchMap((communication) => this.messagingThreadsService.notifyThreadMessage(threadId, {
            organizationId,
            sender: {
              ...sender,
              resourceType: senderResourceType
            },
            context,
            subject,
            message: {
              communicationId: communication?.id,
              preview,
              text: preview,
              sentAt: communicationSentAt,
              route: {
                screen: 'MessagingThread',
                routePath: '/app/messaging/thread',
                queryParams: { threadId },
                threadId,
                resourceType: 'ServiceRequest',
                resourceId: serviceRequest.id
              },
              metadata: {
                serviceRequestId: serviceRequest.id,
                serviceRequestType,
                legacyNotificationType: 'service-request-created',
                communicationSender: 'system'
              }
            }
          }).pipe(
            tap((notifyResult) => {
              console.log('notifyThreadMessage result', notifyResult);
            }),
            catchError((error) => {
              console.error('Ã¢ÂÅ’ [MESSAGING] Failed to notify service request messaging thread', error);
              return of(null);
            })
          )),
          catchError((error) => {
            console.error('Ã¢ÂÅ’ [MESSAGING] Failed to create system communication for service request', error);
            console.log('falling back to notifyThreadMessage without Communication resource');
            return this.messagingThreadsService.notifyThreadMessage(threadId, {
              organizationId,
              sender: {
                ...sender,
                resourceType: senderResourceType
              },
              context,
              subject,
              message: {
                preview,
                text: preview,
                sentAt: communicationSentAt,
                route: {
                  screen: 'MessagingThread',
                  routePath: '/app/messaging/thread',
                  queryParams: { threadId },
                  threadId,
                  resourceType: 'ServiceRequest',
                  resourceId: serviceRequest.id
                },
                metadata: {
                  serviceRequestId: serviceRequest.id,
                  serviceRequestType,
                  legacyNotificationType: 'service-request-created',
                  communicationSender: 'system'
                }
              }
            }).pipe(
              tap((notifyResult) => {
                console.log('fallback notifyThreadMessage result', notifyResult);
              }),
              catchError((notifyError) => {
                console.error('Ã¢ÂÅ’ [MESSAGING] Failed to notify service request messaging thread', notifyError);
                return of(null);
              })
            );
          })
        );
      })
    ).subscribe((result) => {
      if (result?.threadId) {
        console.log(`Ã¢Å“â€¦ [MESSAGING] Service request thread notification sent for thread ${result.threadId}`);
      }
      console.log('final messaging result', result);
      console.groupEnd();
    });
  }

  public ensureMedicationRequestMessagingThread(
    medicationRequest: MedicationRequest,
    additionalExplicitRecipients: string[] = [],
    messagingRecipientRolesOverride: string[] = []
  ): Observable<EnsureThreadResponse | null> {
    const sender = this.buildCurrentMessagingParticipant();
    const organizationId = this.authService.getOrganizationId();

    if (!organizationId || !sender || !medicationRequest?.id) {
      console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] Missing required thread inputs', {
        hasOrganizationId: !!organizationId,
        hasSender: !!sender,
        medicationRequestId: medicationRequest?.id
      });
      return of(null);
    }

    const medicationDisplay = medicationRequest.medicationReference?.display 
      || medicationRequest.medicationCodeableConcept?.text 
      || 'this medication';

    const subject = this.buildMedicationRequestMessagingSubject(medicationRequest);
    const context = {
      contextType: 'medication-request',
      contextId: medicationRequest.id,
      medicationRequestId: medicationRequest.id,
      metadata: {
        priority: medicationRequest.priority || 'routine',
        intent: medicationRequest.intent || 'order'
      }
    };

    const senderExplicitRecipients = this.extractMessagingParticipantsFromReferences(
      [
        ...(Array.isArray(medicationRequest?.performer) ? medicationRequest.performer : (medicationRequest.performer ? [medicationRequest.performer] : [])),
        ...additionalExplicitRecipients,
        ...(medicationRequest.requester ? [medicationRequest.requester] : [])
      ],
      sender.participantId
    );

    return this.resolveMessagingParticipantsForRoles(
      messagingRecipientRolesOverride.length ? messagingRecipientRolesOverride : this.getMedicationRequestMessagingRecipientRoles(),
      organizationId,
      sender.participantId
    ).pipe(
      map((organizationRecipients) => this.mergeMessagingParticipants(senderExplicitRecipients, organizationRecipients)),
      switchMap((participants) => {
        if (!participants.length) {
          console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] No practitioner recipients resolved for medication request messaging thread');
          return of(null);
        }

        return this.messagingThreadsService.ensureThread({
          organizationId,
          threadType: 'medication-request',
          sender,
          participants,
          context,
          subject,
          title: `Medication Request: ${medicationDisplay}`
        });
      }),
      catchError((error) => {
        console.error('Ã¢ÂÅ’ [MESSAGING] Failed to ensure medication request messaging thread', error);
        return of(null);
      })
    );
  }

  private triggerMedicationRequestMessagingThread(
    medicationRequest: MedicationRequest,
    requestData: any,
    title: string,
    medicationDisplay: string,
    organizationId: string,
    additionalExplicitRecipients: string[] = [],
    messagingRecipientRolesOverride: string[] = []
  ): void {
    const sender = this.buildCurrentMessagingParticipant();
    if (!sender) return;

    const senderResourceType = sender.resourceType ?? 'Practitioner';
    const preview = `${sender.display ?? 'Unknown'} prescribed: ${medicationDisplay}`;

    this.ensureMedicationRequestMessagingThread(
      medicationRequest,
      additionalExplicitRecipients,
      messagingRecipientRolesOverride
    ).pipe(
      switchMap((response) => {
        const threadId = response?.thread?.threadId;
        if (!threadId) return of(null);

        const context = response.thread?.context;
        const subject = response.thread?.subject;
        const participants = response.thread?.participants || [];
        const communicationSentAt = new Date().toISOString();

        return this.createSystemMedicationRequestCommunication(
          medicationRequest,
          participants,
          preview,
          communicationSentAt,
          organizationId
        ).pipe(
          switchMap((communication) => this.messagingThreadsService.notifyThreadMessage(threadId, {
            organizationId,
            sender: { ...sender, resourceType: senderResourceType },
            context,
            subject,
            message: {
              communicationId: communication?.id,
              preview,
              text: preview,
              sentAt: communicationSentAt,
              route: {
                screen: 'MessagingThread',
                routePath: '/app/messaging/thread',
                queryParams: { threadId },
                threadId,
                resourceType: 'MedicationRequest',
                resourceId: medicationRequest.id
              },
              metadata: {
                medicationRequestId: medicationRequest.id,
                legacyNotificationType: 'medication-request-created',
                communicationSender: 'system'
              }
            }
          })),
          catchError(() => this.messagingThreadsService.notifyThreadMessage(threadId, {
            organizationId,
            sender: { ...sender, resourceType: senderResourceType },
            context,
            subject,
            message: {
              preview,
              text: preview,
              sentAt: communicationSentAt,
              route: {
                screen: 'MessagingThread',
                routePath: '/app/messaging/thread',
                queryParams: { threadId },
                threadId,
                resourceType: 'MedicationRequest',
                resourceId: medicationRequest.id
              },
              metadata: {
                medicationRequestId: medicationRequest.id,
                legacyNotificationType: 'medication-request-created',
                communicationSender: 'system'
              }
            }
          }))
        );
      })
    ).subscribe();
  }

  public buildCurrentMessagingParticipant(): MessagingParticipant | null {
    const currentUser = this.authService.getCurrentUser();
    const participantId = (currentUser?.fhirResourceId || currentUser?.userId || currentUser?.id || '').toString().trim();
    if (!participantId) {
      return null;
    }

    const role = (currentUser?.role || '').toString().trim().toLowerCase();
    const isPatient = role === SystemRoles.Patient;
    const resourceType = isPatient ? 'Patient' : 'Practitioner';

    return {
      participantId,
      resourceType,
      resourceId: participantId,
      display: (currentUser?.display || currentUser?.name || currentUser?.email || participantId).toString(),
      roleName: role || undefined,
      participantType: resourceType.toLowerCase()
    };
  }

  private buildServiceRequestMessagingSubject(serviceRequest: any): MessagingSubject | undefined {
    const patientId = (serviceRequest?.subject?.reference || '').toString().split('/')[1] || '';
    if (!patientId) {
      return undefined;
    }

    const patientDisplay = serviceRequest?.subject?.display
      || this.stateService.PatientResources.currentPatient.getValue()?.actualResource?.name?.[0]?.text
      || `Patient ${patientId}`;

    return {
      resourceType: 'Patient',
      resourceId: patientId,
      display: patientDisplay
    };
  }

  public buildMedicationRequestMessagingSubject(medicationRequest: MedicationRequest): MessagingSubject | undefined {
    const patientId = (medicationRequest?.subject?.reference || '').toString().split('/')[1] || '';
    if (!patientId) {
      return undefined;
    }

    const patientDisplay = medicationRequest?.subject?.display
      || this.stateService.PatientResources.currentPatient.getValue()?.actualResource?.name?.[0]?.text
      || `Patient ${patientId}`;

    return {
      resourceType: 'Patient',
      resourceId: patientId,
      display: patientDisplay
    };
  }

  private createSystemMedicationRequestCommunication(
    medicationRequest: MedicationRequest,
    participants: MessagingParticipant[],
    preview: string,
    sentAt: string,
    organizationId: string
  ) {
    const communicationUrl = `${this.backendEndPoint}/Communication`;
    const communication: Communication = {
      resourceType: 'Communication',
      status: 'completed',
      sent: sentAt,
      basedOn: [{ reference: `MedicationRequest/${medicationRequest.id}` }],
      subject: medicationRequest?.subject,
      encounter: medicationRequest?.encounter,
      sender: {
        reference: `Organization/${organizationId}`,
        display: 'System'
      },
      recipient: participants
        .filter((participant) => participant.resourceType === 'Practitioner' && participant.resourceId)
        .map((participant) => ({
          reference: `${participant.resourceType}/${participant.resourceId}`,
          display: participant.display
        })),
      payload: [
        {
          contentString: preview
        }
      ]
    };

    console.groupCollapsed('Ã°Å¸â€™Â¬ [MESSAGING] createSystemMedicationRequestCommunication');
    console.log('communicationUrl', communicationUrl);
    console.log('medicationRequest.id', medicationRequest?.id);
    console.log('participants', participants);
    console.log('communication payload', communication);
    console.groupEnd();

    return this.http.post<Communication>(communicationUrl, communication).pipe(
      catchError((error) => {
        console.error('Ã¢ÂÅ’ [MESSAGING] Failed to create Communication resource', error);
        return of(null);
      })
    );
  }

  private createSystemServiceRequestCommunication(
    serviceRequest: any,
    participants: MessagingParticipant[],
    preview: string,
    sentAt: string,
    organizationId: string
  ) {
    const communicationUrl = `${this.backendEndPoint}/Communication`;
    const communication: Communication = {
      resourceType: 'Communication',
      status: 'completed',
      sent: sentAt,
      basedOn: [{ reference: `ServiceRequest/${serviceRequest.id}` }],
      subject: serviceRequest?.subject,
      encounter: serviceRequest?.encounter,
      sender: {
        reference: `Organization/${organizationId}`,
        display: 'System'
      },
      recipient: participants
        .filter((participant) => participant.resourceType === 'Practitioner' && participant.resourceId)
        .map((participant) => ({
          reference: `${participant.resourceType}/${participant.resourceId}`,
          display: participant.display
        })),
      payload: [
        {
          contentString: preview
        }
      ]
    };

    console.groupCollapsed('Ã°Å¸â€™Â¬ [MESSAGING] createSystemServiceRequestCommunication');
    console.log('communicationUrl', communicationUrl);
    console.log('serviceRequest.id', serviceRequest?.id);
    console.log('participants', participants);
    console.log('communication payload', communication);
    console.groupEnd();

    return this.http.post<Communication>(communicationUrl, communication).pipe(
      catchError((error) => {
        console.error('Ã¢ÂÅ’ [MESSAGING] Failed to create Communication resource', error);
        return of(null);
      })
    );
  }

  private resolveMessagingParticipantsForRoles(
    targetRoles: string[],
    organizationId: string,
    senderParticipantId: string
  ) {
    console.groupCollapsed('Ã°Å¸Â§Â­ [MESSAGING] resolveMessagingParticipantsForRoles');
    console.log('incoming targetRoles', targetRoles);
    console.log('organizationId', organizationId);
    console.log('senderParticipantId', senderParticipantId);

    const normalizedRoles = new Set(
      targetRoles
        .map((role) => this.normalizeMessagingRoleToken(role))
        .filter(Boolean)
    );

    console.log('normalized target roles', Array.from(normalizedRoles));

    if (!normalizedRoles.size) {
      console.warn('Ã¢Å¡Â Ã¯Â¸Â [MESSAGING] No normalized target roles to resolve');
      console.groupEnd();
      return of([] as MessagingParticipant[]);
    }

    const organizationQuery = `${this.backendEndPoint}/PractitionerRole?organization=Organization/${encodeURIComponent(organizationId)}&_count=200`;
    console.log('PractitionerRole query', organizationQuery);

    return this.http.get<Bundle<PractitionerRole>>(organizationQuery, {
      context: new HttpContext().set(LoadingUIEnabled, false).set(SkipHospitalSegregation, true)
    }).pipe(
      tap((bundle) => {
        console.log('PractitionerRole bundle total entries', bundle?.entry?.length || 0);
      }),
      catchError((error) => {
        console.error('Ã¢ÂÅ’ [MESSAGING] PractitionerRole query failed', error);
        console.groupEnd();
        return of(null);
      }),
      map((bundle) => {
        const byPractitioner = new Map<string, MessagingParticipant>();

        for (const entry of bundle?.entry ?? []) {
          const roleResource = entry?.resource;
          if (roleResource?.resourceType !== 'PractitionerRole') {
            console.log('skipping non-PractitionerRole entry', roleResource);
            continue;
          }

          const practitionerRef = (roleResource.practitioner?.reference || '').toString().trim();
          const practitionerId = practitionerRef.split('/')[1];
          const extractedTokens = this.extractPractitionerRoleTokens(roleResource);
          const matches = extractedTokens.some((token) => normalizedRoles.has(token));
          console.log('evaluating PractitionerRole', {
            practitionerRef,
            practitionerId,
            extractedTokens,
            matches,
            senderParticipantId,
            alreadyAdded: byPractitioner.has(practitionerId)
          });

          if (!matches) {
            continue;
          }
          console.log([`matched PractitionerRole for practitioner ${practitionerId}`, practitionerId, senderParticipantId]);
          if (!practitionerId || practitionerId === senderParticipantId || byPractitioner.has(practitionerId)) {
            console.log('skipping matched practitioner', {
              practitionerId,
              reason: !practitionerId
                ? 'missing practitionerId'
                : practitionerId === senderParticipantId
                  ? 'same as sender'
                  : 'already added'
            });
            continue;
          }

          byPractitioner.set(practitionerId, {
            participantId: practitionerId,
            resourceType: 'Practitioner',
            resourceId: practitionerId,
            display: roleResource.practitioner?.display || `Practitioner ${practitionerId}`,
            roleName: this.extractPrimaryPractitionerRoleLabel(roleResource),
            participantType: 'practitioner'
          });
          console.log('added practitioner recipient candidate', byPractitioner.get(practitionerId));
        }

        const participants = Array.from(byPractitioner.values());
        console.log('participants before hydration', participants);
        return participants;
      }),
      switchMap((participants) => this.hydrateMessagingParticipants(participants).pipe(
        tap((hydratedParticipants) => {
          console.log('participants after hydration', hydratedParticipants);
          console.groupEnd();
        })
      ))
    );
  }

  private getServiceRequestMessagingRecipientRoles(serviceRequestType?: string): string[] {
    const type = (serviceRequestType || 'others').toLowerCase().trim();

    switch (type) {
      case 'laboratory':
        return [SystemRoles.LabTechnician, SystemRoles.AlliedHealthProfessional];
      case 'imaging':
        return [ SystemRoles.AlliedHealthProfessional];
      case 'pharmacy':
        return [SystemRoles.Pharmacist, SystemRoles.AlliedHealthProfessional];
      case 'surgery':
        return [SystemRoles.Doctor, SystemRoles.PrimaryHealthcareProvider, SystemRoles.AlliedHealthProfessional];
      case 'procedure':
        return [SystemRoles.HealthcareAssistant, SystemRoles.Doctor, SystemRoles.PrimaryHealthcareProvider, SystemRoles.AlliedHealthProfessional];
      default:
        // Fallback for unknown types - minimal set to avoid noise
        return [SystemRoles.AlliedHealthProfessional];
    }
  }

  private getMedicationRequestMessagingRecipientRoles(): string[] {
    return [
      SystemRoles.Pharmacist,
      SystemRoles.AlliedHealthProfessional
    ];
  }

  private mergeMessagingParticipants(...participantGroups: MessagingParticipant[][]): MessagingParticipant[] {
    const merged = new Map<string, MessagingParticipant>();

    for (const group of participantGroups) {
      for (const participant of group ?? []) {
        const participantId = (participant?.participantId || '').toString().trim();
        if (!participantId || merged.has(participantId)) {
          continue;
        }

        merged.set(participantId, participant);
      }
    }

    return Array.from(merged.values());
  }

  private hydrateMessagingParticipants(participants: MessagingParticipant[]) {
    console.groupCollapsed('Ã°Å¸ÂªÂª [MESSAGING] hydrateMessagingParticipants');
    console.log('incoming participants', participants);
    if (!participants.length) {
      console.log('no participants to hydrate');
      console.groupEnd();
      return of([] as MessagingParticipant[]);
    }

    return forkJoin(
      participants.map((participant) =>
        this.http.get<Practitioner>(`${this.backendEndPoint}/Practitioner/${encodeURIComponent(participant.participantId)}`).pipe(
          tap((practitioner) => {
            console.log('hydrated practitioner resource', {
              participantId: participant.participantId,
              practitioner
            });
          }),
          map((practitioner) => ({
            ...participant,
            display: this.getPractitionerMessagingDisplay(practitioner, participant.participantId)
          })),
          catchError((error) => {
            console.error('Ã¢ÂÅ’ [MESSAGING] Failed to hydrate practitioner', {
              participantId: participant.participantId,
              error
            });
            return of(participant);
          })
        )
      )
    ).pipe(
      tap((hydrated) => {
        console.log('hydrateMessagingParticipants result', hydrated);
        console.groupEnd();
      })
    );
  }

  private extractMessagingParticipantsFromReferences(references: any[], senderParticipantId: string): MessagingParticipant[] {
    console.groupCollapsed('Ã°Å¸â€â€” [MESSAGING] extractMessagingParticipantsFromReferences');
    console.log('raw references', references);
    console.log('senderParticipantId', senderParticipantId);
    const deduped = new Map<string, MessagingParticipant>();

    for (const ref of references ?? []) {
      const reference = (ref?.reference || ref || '').toString().trim();
      console.log('evaluating explicit recipient reference', { ref, reference });
      if (!reference.startsWith('Practitioner/')) {
        console.log('skipping explicit recipient because reference is not Practitioner/*', reference);
        continue;
      }

      const practitionerId = reference.split('/')[1];
      if (!practitionerId || practitionerId === senderParticipantId || deduped.has(practitionerId)) {
        console.log('skipping explicit recipient', {
          practitionerId,
          reason: !practitionerId
            ? 'missing practitionerId'
            : practitionerId === senderParticipantId
              ? 'same as sender'
              : 'already deduped'
        });
        continue;
      }

      deduped.set(practitionerId, {
        participantId: practitionerId,
        resourceType: 'Practitioner',
        resourceId: practitionerId,
        display: ref?.display || `Practitioner ${practitionerId}`,
        participantType: 'practitioner'
      });
      console.log('added explicit recipient', deduped.get(practitionerId));
    }

    const explicitRecipients = Array.from(deduped.values());
    console.log('final explicit recipients', explicitRecipients);
    console.groupEnd();
    return explicitRecipients;
  }

  private practitionerRoleMatchesAnyTarget(roleResource: PractitionerRole, normalizedRoles: Set<string>): boolean {
    const roleTokens = this.extractPractitionerRoleTokens(roleResource);
    return roleTokens.some((token) => normalizedRoles.has(token));
  }

  private extractPractitionerRoleTokens(roleResource: PractitionerRole): string[] {
    const concepts = Array.isArray(roleResource.code) ? roleResource.code : [];
    const tokens = concepts.flatMap((concept) => {
      const codings = Array.isArray(concept?.coding) ? concept.coding : [];
      return [
        concept?.text,
        ...codings.map((coding) => coding?.code),
        ...codings.map((coding) => coding?.display)
      ];
    });

    return tokens
      .map((value) => this.normalizeMessagingRoleToken(value))
      .filter(Boolean) as string[];
  }

  private extractPrimaryPractitionerRoleLabel(roleResource: PractitionerRole): string | undefined {
    const concept = Array.isArray(roleResource.code) ? roleResource.code[0] : undefined;
    const coding = Array.isArray(concept?.coding) ? concept.coding[0] : undefined;
    const raw = concept?.text || coding?.display || coding?.code || undefined;
    const normalized = this.normalizeMessagingRoleToken(raw);
    if (!normalized) {
      return undefined;
    }

    const displayMap: Record<string, string> = {
      [SystemRoles.Doctor]: ROLE_DISPLAY_NAMES[SystemRoles.Doctor],
      [SystemRoles.HealthcareAssistant]: ROLE_DISPLAY_NAMES[SystemRoles.HealthcareAssistant],
      [SystemRoles.LabTechnician]: ROLE_DISPLAY_NAMES[SystemRoles.LabTechnician],
      [SystemRoles.Pharmacist]: ROLE_DISPLAY_NAMES[SystemRoles.Pharmacist],
      [SystemRoles.RemoteDoctor]: ROLE_DISPLAY_NAMES[SystemRoles.RemoteDoctor],
      [SystemRoles.AlliedHealthProfessional]: ROLE_DISPLAY_NAMES[SystemRoles.AlliedHealthProfessional],
      [SystemRoles.HospitalAdmin]: ROLE_DISPLAY_NAMES[SystemRoles.HospitalAdmin],
      [SystemRoles.HealthcareAdmin]: ROLE_DISPLAY_NAMES[SystemRoles.HealthcareAdmin],
      [SystemRoles.Cashier]: ROLE_DISPLAY_NAMES[SystemRoles.Cashier]
    };

    return displayMap[normalized] || raw;
  }

  private normalizeMessagingRoleToken(value: unknown): string {
    return (value ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  private getPractitionerMessagingDisplay(practitioner: Practitioner, fallbackId: string): string {
    const name = practitioner?.name?.[0];
    const parts = [
      ...(Array.isArray(name?.prefix) ? name.prefix : []),
      ...(Array.isArray(name?.given) ? name.given : []),
      name?.family
    ].filter(Boolean);

    return parts.length ? parts.join(' ') : (practitioner?.id || fallbackId);
  }

  private extractServiceRequestCategoryLabel(category: any): string {
    const categories = Array.isArray(category) ? category : [category];
    for (const item of categories) {
      const label = item?.text || item?.coding?.[0]?.display || item?.coding?.[0]?.code;
      if (label) {
        return label;
      }
    }

    return '';
  }




  activateServiceRequest(existingSr: any) {
    const rawSr = {
      ...existingSr,
      status: 'active',
      intent: 'order',
      authoredOn: new Date().toISOString()
    };

    // Remove UI-specific helper fields that cause FHIR parsing errors
    delete rawSr.hasBalancedInvoice;
    delete rawSr.available;
    delete rawSr.systemReference;
    delete rawSr.Resource_Identifier;
    delete rawSr.relatedChargeItems;
    delete rawSr.relatedInvoices;
    
    const updatedSr = {
      ...this.fhirTransformService.transformValues('ServiceRequest', rawSr),
      id: rawSr.id,
      meta: rawSr.meta,
      subject: rawSr.subject,
      encounter: rawSr.encounter,
      requester: rawSr.requester,
      code: rawSr.code,
      category: rawSr.category,
      status: rawSr.status,
      intent: rawSr.intent,
      priority: rawSr.priority,
      authoredOn: rawSr.authoredOn
    };
    
    const serviceRequestBundle = [updatedSr];
    const values = [updatedSr];
    const generateInvoice = true;
    const typeOfService = existingSr.category?.[0]?.text || 'Service';

          const makeUrnUuid = () => {
            try {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const anyCrypto: any = (globalThis as any)?.crypto;
              const id = anyCrypto?.randomUUID?.();
              return `urn:uuid:${id || Math.random().toString(16).slice(2)}`;
            } catch {
              return `urn:uuid:${Math.random().toString(16).slice(2)}`;
            }
          };

          const serviceRequestWithFullUrl = (serviceRequestBundle || []).map((resource: any) => {
            // NOTE: `isActive` is a UI/helper flag and must never be posted to FHIR.
            // We keep it only on the wrapper object for local decision-making.


            return {
              resource,
              fullUrl: makeUrnUuid(),

            };
          });

          const serviceRequestEntries = serviceRequestWithFullUrl.map((x: any) => ({
            fullUrl: x.fullUrl,
            resource: x.resource,
            request: {
              method: x.resource.id ? 'PUT' : 'POST',
              url: x.resource.id ? `ServiceRequest/${x.resource.id}` : 'ServiceRequest'
            }
          }));

          const buildAndPost = (extraEntries: any[] = []) => {
            console.log('Preparing to post Service Request Bundle with extra entries:', serviceRequestEntries, extraEntries);
// $#$            // /* debugger; */
// $#$            // /* alert('building and posting'); */
            const fhirBundle = {
              resourceType: 'Bundle',
              type: 'transaction',
              entry: [...serviceRequestEntries, ...extraEntries]
            } as Bundle<any>;

            this.fhirResourceService.postBundle(fhirBundle).subscribe({
              next: (res: any) => {
                console.log('Service Request Bundle posted successfully:', res);
                console.log('========== FULL SERVER RESPONSE DEBUG ==========');
                console.log('Ã°Å¸â€œÂ¦ Full res object:', res);
                console.log('Ã°Å¸â€œÂ¦ res.bundle:', res?.bundle);
                console.log('Ã°Å¸â€œÂ¦ res.bundle type:', res?.bundle?.type);
                console.log('Ã°Å¸â€œÂ¦ Number of entries:', res?.bundle?.entry?.length);
                const responseBundle = res?.bundle || res;
                const responseHeaders = res?.headers; // Ã¢Å“â€¦ Get headers from response

                if (responseBundle?.entry && Array.isArray(responseBundle.entry)) {
                  responseBundle.entry.forEach((entry: any, index: number) => {
                    if (entry.resource && entry.resource.resourceType === 'ServiceRequest') {
                      const persistedServiceRequest = entry.resource;
                      const originalRequestData = values[index] || {};

                      // Ã¢Å“â€¦ Multi-strategy ID extraction
                      let serviceRequestId: string | null = persistedServiceRequest.id;

                      // Strategy 1: Direct from resource.id
                      if (serviceRequestId) {
                        console.log('Ã¢Å“â€¦ Got ID from resource.id:', serviceRequestId);
                      }

                      // Strategy 2: Extract from entry.response.location
                      if (!serviceRequestId && entry.response?.location) {
                        const locationUrl = entry.response.location;
                        console.log('Ã°Å¸â€œÂ Entry location URL:', locationUrl);
                        const match = locationUrl.match(/ServiceRequest\/([^\/\?#_]+)/);
                        serviceRequestId = match ? match[1] : null;
                        if (serviceRequestId) {
                          console.log('Ã¢Å“â€¦ Extracted ID from entry.response.location:', serviceRequestId);
                        }
                      }

                      // Strategy 3: Try fullUrl if it's not a urn:uuid
                      if (!serviceRequestId && entry.fullUrl && !entry.fullUrl.startsWith('urn:uuid:')) {
                        const match = entry.fullUrl.match(/ServiceRequest\/([^\/\?#_]+)/);
                        serviceRequestId = match ? match[1] : null;
                        if (serviceRequestId) {
                          console.log('Ã¢Å“â€¦ Extracted ID from fullUrl:', serviceRequestId);
                        }
                      }

                      // Strategy 4: Check HTTP Location header (for single resource responses)
                      if (!serviceRequestId && responseHeaders) {
                        const locationHeader = responseHeaders.get('Location');
                        if (locationHeader) {
                          console.log('Ã°Å¸â€œÂ HTTP Location header:', locationHeader);
                          const match = locationHeader.match(/ServiceRequest\/([^\/\?#_]+)/);
                          serviceRequestId = match ? match[1] : null;
                          if (serviceRequestId) {
                            console.log('Ã¢Å“â€¦ Extracted ID from HTTP Location header:', serviceRequestId);
                          }
                        }
                      }

                      console.log('Ã°Å¸Å½Â¯ Final ServiceRequest ID:', serviceRequestId);
                      console.log('Ã°Å¸â€œâ€¹ Original request data:', originalRequestData);

                      if (serviceRequestId) {
                        // Create the full ServiceRequest object with the ID
                        const fullServiceRequest = {
                          ...persistedServiceRequest,
                          id: serviceRequestId
                        };

                        this.notifyServiceRequestCreated(
                          fullServiceRequest,
                          originalRequestData
                        );
                      } else {
                        console.error('Ã¢ÂÅ’ ServiceRequest has no ID after all extraction attempts, skipping notification');
                        console.error('Entry structure:', JSON.stringify(entry, null, 2));
                        console.error('Response headers:', responseHeaders);
                      }
                    }
                  });
                } else {
                  console.warn('Ã¢Å¡Â Ã¯Â¸Â Response bundle has unexpected structure:', responseBundle);
                }

                // CORRECTED: Extract ID from the wrapped response
                // if (returnServiceRequestId) {
                //   // Access the bundle from the wrapper object
                //   const responseBundle = res?.bundle || res;

                //   // Try multiple extraction strategies
                //   let serviceRequestId: string | null = null;

                //   // Strategy 1: Extract from response.location header
                //   if (responseBundle?.entry?.[0]?.response?.location) {
                //     const locationUrl = responseBundle.entry[0].response.location;
                //     const idMatch = locationUrl.match(/ServiceRequest\/([^\/\?]+)/);
                //     serviceRequestId = idMatch ? idMatch[1] : null;
                //   }

                //   // Strategy 2: Extract from returned resource.id
                //   if (!serviceRequestId && responseBundle?.entry?.[0]?.resource?.id) {
                //     serviceRequestId = responseBundle.entry[0].resource.id;
                //   }

                //   console.log('Extracted Service Request ID:', serviceRequestId);

                //   if (serviceRequestId) {
                //     // Successfully extracted ID - can be used for linking
                //     // return { reference: `ServiceRequest/${serviceRequestId}` }//, id: serviceRequestId };
                //   } else {
                //     console.warn('Could not extract Service Request ID from response');

                //   }
                // } else {

                // }

                //SUCCESSMESSAGE SNACKBAR
                const successMessage = typeOfService ? `${typeOfService} Request activated successfully.` : 'Service Request activated successfully.';
                this.snackBar.openFromComponent(SuccessMessageComponent, {
                  data: successMessage,
                  duration: 3000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                });
                // TRIGGER REFRESH
                this.resourceRefresh.notify('ServiceRequest', { full: true });
              },

              error: (err: any) => {
                console.error('Error posting Service Request Bundle:', err);
                this.errorService.openandCloseError(`Error activating ${typeOfService ? typeOfService : "Service"} Request(s). Please try again later.`);
                // if (returnServiceRequestId) return null;
                // return null;
              }
            });
          };

          if (!generateInvoice) {
// $#$            // /* debugger; */
            serviceRequestEntries.forEach((x: any) => {
              delete (x.resource.isActive);
            });
            buildAndPost();
            return;
          }

          (forkJoin(
            (serviceRequestWithFullUrl || []).map((x: any) => {
              const sr = x.resource;
              console.log(sr);
              const isActive = x.isActive !== false;
              delete (x.resource.isActive);
              
              if (!isActive || sr.status !== 'active') {
                return of({});
              }
// $#$              // /* alert(x.resource.code.coding[0].code); */
              return this.utilityService.getServiceRequestCategoryForCode(x.resource?.code?.coding?.[0]?.code || '').pipe(
                switchMap((category) => {
                  if (!category) {
                    //code is not active
                    console.log('not active');
                    // buildAndPost();
// $#$                    // /* debugger; */
                    return of({});


                  } else {
                    console.log('active');
// $#$                    // /* debugger; */

                    return this.prepareChargeItemAndInvoiceForServiceRequest(sr as any, x.fullUrl).pipe(
                      catchError(() => of(null))

                    )
                  }

                }));


            }) as any
          ) as Observable<any[]>).subscribe((results: any[]) => {

            const extraEntries = ((results || []) as any[])
              .filter(Boolean).filter(r => {
// $#$                // /* alert(JSON.stringify(r) */);
                // console.log(r);
// $#$                // /* debugger; */
                return Object.keys(r).length > 0;
              })
              .flatMap((r: any) => {
// $#$                // /* alert(JSON.stringify(r) */);
// $#$                // /* debugger */
                const svc = (r.serviceEntries || []) as any[];
                return [
                  ...svc.map((e: any) => ({
                    fullUrl: e.fullUrl,
                    resource: e.resource,
                    request: e.request
                  })),
                  {
                    fullUrl: r.chargeItemEntry.fullUrl,
                    resource: r.chargeItemEntry.resource,
                    request: r.chargeItemEntry.request
                  },
                  {
                    fullUrl: r.invoiceEntry.fullUrl,
                    resource: r.invoiceEntry.resource,
                    request: r.invoiceEntry.request
                  }
                ];
              });

            buildAndPost(extraEntries);
          });

        };

  }

